import "client-only";
import { jsx as t, jsxs as f, Fragment as ue } from "react/jsx-runtime";
import * as Ke from "react";
import { forwardRef as k, useLayoutEffect as Cn, useEffect as pe, useMemo as Z, createContext as ee, useContext as H, useId as K, useState as Se, useRef as O, useCallback as ce, useImperativeHandle as ve, createElement as Bt, Fragment as Tt, useReducer as In } from "react";
import { Content as $n, Item as Pn, Root as Sn, Trigger as Rn } from "@radix-ui/react-accordion";
import { announce as Dn, destroyAnnouncer as Vn } from "@react-aria/live-announcer";
import { Slot as me, Slottable as Bn } from "@radix-ui/react-slot";
import { OpenInNewIcon as Ft, InfoIcon as Tn, QuestionMarkIcon as Fn, CloseIcon as Mt, ChevronLeftIcon as Lt, ChevronRightIcon as jt, InfoRingIcon as Mn, ExclamationRingIcon as Ln, SuccessRingIcon as jn, XRingIcon as zn, SBABLogo as qn } from "@sbab-ui/icons";
import { Root as An, Trigger as On, Content as Wn } from "@radix-ui/react-collapsible";
import { useFocusWithin as zt, I18nProvider as En, useLocale as Ye, useDateField as Hn, useDateSegment as Gn, usePopover as Un, Overlay as Zn, DismissButton as yt, useDialog as Kn, useCalendar as Qn, useRangeCalendar as Xn, useCalendarGrid as Jn, useCalendarCell as Yn, useButton as qt, useDatePicker as ea, useDateRangePicker as ta, useNumberField as At, useSwitch as na, useFocusRing as aa, usePress as ia, useKeyboard as la, mergeProps as ra } from "react-aria";
import { GregorianCalendar as oa, endOfMonth as ca, getWeeksInMonth as sa, isSameMonth as da, isSameDay as xt, parseDate as G } from "@internationalized/date";
import { useDateFieldState as _a, useCalendarState as ua, useRangeCalendarState as pa, useDatePickerState as ma, useDateRangePickerState as ha, useNumberFieldState as Ot, useToggleState as ba } from "react-stately";
import { usePreventScroll as ga } from "@react-aria/overlays";
function fa() {
  let n = 0, e, a = "";
  for (; n < arguments.length; )
    (e = arguments[n++]) && (a && (a += " "), a += e);
  return a;
}
const b = fa, ya = "_AccordionItem_izn6p_5", xa = "_AccordionTrigger_izn6p_18", va = "_AccordionContent_izn6p_63", wa = "_slideDown_izn6p_1", Na = "_slideUp_izn6p_1", ka = "_AccordionContentContainer_izn6p_75", Me = {
  AccordionItem: ya,
  AccordionTrigger: xa,
  AccordionContent: va,
  slideDown: wa,
  slideUp: Na,
  AccordionContentContainer: ka
};
function Ca({ children: n, className: e, ...a }, i) {
  return /* @__PURE__ */ t(
    $n,
    {
      ...a,
      className: b(Me.AccordionContent, e),
      ref: i,
      children: /* @__PURE__ */ t("div", { className: Me.AccordionContentContainer, children: n })
    }
  );
}
const Ia = /* @__PURE__ */ k(
  Ca
);
function $a() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
const Pa = $a() ? Cn : pe;
let Oe = !1, Sa = 0;
function vt() {
  return ++Sa;
}
const wt = Ke.useId;
function Ra(n) {
  if (wt !== void 0)
    return wt();
  let e = Oe ? vt() : null, [a, i] = Ke.useState(e);
  return Pa(() => {
    a === null && i(vt());
  }, []), Ke.useEffect(() => {
    Oe === !1 && (Oe = !0);
  }, []), a ?? void 0;
}
function we() {
  return Ra();
}
const Da = /* @__PURE__ */ k(
  function({ className: e, onExpand: a, ...i }, l) {
    const r = we();
    return /* @__PURE__ */ t(
      Pn,
      {
        ...i,
        className: b(Me.AccordionItem, e),
        onClick: (o) => {
          var s, d;
          const { target: c } = o;
          ((s = c.dataset) == null ? void 0 : s.accordionTrigger) === "true" && ((d = c.dataset) == null ? void 0 : d.state) === "closed" && (a == null || a());
        },
        value: `${r}-value`,
        ref: l
      }
    );
  }
);
function Va({ children: n, ...e }, a) {
  return /* @__PURE__ */ t(Sn, { ...e, ref: a, type: "multiple", children: n });
}
const Ba = /* @__PURE__ */ k(
  Va
);
function Ta({ children: n, className: e, ...a }, i) {
  return /* @__PURE__ */ f(
    Rn,
    {
      ...a,
      className: b(Me.AccordionTrigger, e),
      "data-accordion-trigger": "true",
      ref: i,
      children: [
        n,
        /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: [
          /* @__PURE__ */ t("rect", { x: "3", y: "10.5", width: "18", height: "3" }),
          /* @__PURE__ */ t("rect", { x: "10.5", y: "3", width: "3", height: "18" })
        ] })
      ]
    }
  );
}
const Fa = /* @__PURE__ */ k(
  Ta
), vo = {
  Content: Ia,
  Root: Ba,
  Trigger: Fa,
  Item: Da
}, Ma = "_badge_1x5ll_1", xe = {
  badge: Ma,
  "badge--neutral": "_badge--neutral_1x5ll_12",
  "badge--critical": "_badge--critical_1x5ll_18",
  "badge--warning": "_badge--warning_1x5ll_24",
  "badge--positive": "_badge--positive_1x5ll_30"
};
function La(n, e) {
  return Z(
    () => b(
      xe.badge,
      n === "neutral" && xe["badge--neutral"],
      n === "critical" && xe["badge--critical"],
      n === "warning" && xe["badge--warning"],
      n === "positive" && xe["badge--positive"],
      e
    ),
    [n, e]
  );
}
const wo = /* @__PURE__ */ k(
  function({ children: e, className: a, icon: i, variant: l = "neutral" }, r) {
    const o = La(l, a);
    return /* @__PURE__ */ f(
      "div",
      {
        className: b(o),
        role: "status",
        "aria-live": "polite",
        ref: r,
        children: [
          i && /* @__PURE__ */ t(i, { className: xe.icon, size: "1em", "aria-hidden": "true" }),
          e
        ]
      }
    );
  }
), Wt = ee("sv");
function No({ children: n, locale: e }) {
  return /* @__PURE__ */ t(Wt.Provider, { value: e, children: n });
}
function he() {
  return H(Wt);
}
const ja = "_spinner_1n8e2_1", za = "_spin_1n8e2_1", qa = "_spinner__inner_1n8e2_15", Aa = "_dash_1n8e2_1", We = {
  spinner: ja,
  spin: za,
  "spinner--small": "_spinner--small_1n8e2_5",
  "spinner--large": "_spinner--large_1n8e2_8",
  "spinner--fill": "_spinner--fill_1n8e2_11",
  spinner__inner: qa,
  dash: Aa
};
function Oa({ className: n, color: e, innerRef: a, size: i, ...l }, r) {
  return /* @__PURE__ */ t(
    "svg",
    {
      ...l,
      viewBox: "0 0 24 24",
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      className: b(
        We.spinner,
        i && We[`spinner--${i}`],
        n
      ),
      ref: r ?? a,
      children: /* @__PURE__ */ t(
        "circle",
        {
          className: We.spinner__inner,
          cx: "12",
          cy: "12",
          r: "10",
          style: e ? { stroke: e } : void 0
        }
      )
    }
  );
}
const Wa = /* @__PURE__ */ k(Oa), Ea = "_button_1v7bx_5", Ha = "_button__spinner_1v7bx_68", Ga = "_button__children_1v7bx_98", Ua = "_disappear_1v7bx_1", Za = "_appear_1v7bx_1", oe = {
  button: Ea,
  "button--disabled": "_button--disabled_1v7bx_26",
  "button--large": "_button--large_1v7bx_42",
  "button--small": "_button--small_1v7bx_48",
  "button--x-small": "_button--x-small_1v7bx_53",
  "button--primary": "_button--primary_1v7bx_58",
  button__spinner: Ha,
  "button--secondary": "_button--secondary_1v7bx_71",
  "button--danger": "_button--danger_1v7bx_82",
  "button--loading": "_button--loading_1v7bx_95",
  button__children: Ga,
  disappear: Ua,
  appear: Za
};
function Ka(n, e, a, i) {
  return Z(
    () => b(
      oe.button,
      n && oe[`button--${n}`],
      a && oe[`button--${a}`],
      e && oe[`button--${e}`],
      i
    ),
    [n, e, a, i]
  );
}
const Qa = /* @__PURE__ */ k(
  function({
    asChild: e,
    children: a,
    className: i,
    disabled: l,
    innerRef: r,
    intent: o,
    loading: c,
    loadingAriaLabel: _,
    size: s,
    variant: d,
    ...u
  }, p) {
    const h = he(), m = Ka(
      o,
      s,
      d,
      i
    );
    let g;
    return typeof _ == "string" && _ ? g = _ : typeof _ > "u" && (g = h === "en" ? "Loading" : "Laddar"), pe(() => (c && g && Dn(g, "assertive"), () => {
      Vn();
    }), [c, g]), /* @__PURE__ */ t(
      e ? me : "button",
      {
        type: e ? void 0 : "button",
        ...u,
        disabled: c || l,
        className: b(
          c && oe["button--loading"],
          l && oe["button--disabled"],
          m
        ),
        ref: p ?? r,
        children: c ? /* @__PURE__ */ f(ue, { children: [
          /* @__PURE__ */ t("span", { className: oe.button__children, children: a }),
          /* @__PURE__ */ t("span", { className: oe.button__spinner, children: /* @__PURE__ */ t(
            Wa,
            {
              "aria-hidden": !0,
              "aria-label": g,
              color: "currentColor",
              size: "fill"
            }
          ) })
        ] }) : a
      }
    );
  }
), Xa = "_visuallyHidden_dwm1g_1", Ja = {
  visuallyHidden: Xa
};
function Ya(n, e) {
  return /* @__PURE__ */ t("span", { ...n, className: Ja.visuallyHidden, ref: e });
}
const Y = /* @__PURE__ */ k(
  Ya
);
function Et({ en: n, sv: e }) {
  return he() === "en" ? n : e;
}
const ei = "_link_1dwri_5", ti = "_link__icon_1dwri_22", Nt = {
  link: ei,
  link__icon: ti
};
function Ht(n, e, a) {
  return n && (a = "_blank"), a === "_blank" && !e && (e = "noreferrer noopener"), { rel: e, target: a };
}
const ni = /* @__PURE__ */ k(function({
  asChild: e,
  children: a,
  className: i,
  external: l,
  innerRef: r,
  rel: o,
  target: c,
  ..._
}, s) {
  return { rel: o, target: c } = Ht(l, o, c), /* @__PURE__ */ f(
    e ? me : "a",
    {
      ref: s ?? r,
      className: b(Nt.link, i),
      rel: o,
      target: c,
      ..._,
      children: [
        /* @__PURE__ */ t(Bn, { children: a }),
        c === "_blank" && /* @__PURE__ */ f(Y, { children: [
          "— ",
          /* @__PURE__ */ t(Et, { en: "opens in new tab", sv: "öppnas i ny flik" })
        ] }),
        c === "_blank" && /* @__PURE__ */ t(Ft, { "aria-hidden": !0, className: b(Nt.link__icon) })
      ]
    }
  );
}), ai = {
  "button-link": "_button-link_1s0b3_1",
  "button-link__icon": "_button-link__icon_1s0b3_4"
}, ko = /* @__PURE__ */ k(
  function({
    innerRef: e,
    children: a,
    className: i,
    external: l,
    intent: r,
    rel: o,
    size: c,
    variant: _,
    target: s,
    ...d
  }, u) {
    return { rel: o, target: s } = Ht(l, o, s), /* @__PURE__ */ t(
      Qa,
      {
        asChild: !0,
        variant: _,
        intent: r,
        size: c,
        className: i,
        children: /* @__PURE__ */ f("a", { ...d, ref: u ?? e, rel: o, target: s, children: [
          a,
          s === "_blank" && /* @__PURE__ */ f(Y, { children: [
            "—",
            " ",
            /* @__PURE__ */ t(Et, { en: "opens in new tab", sv: "öppnas i ny flik" })
          ] }),
          s === "_blank" && /* @__PURE__ */ t(
            Ft,
            {
              "aria-hidden": !0,
              className: b(ai["button-link__icon"])
            }
          )
        ] })
      }
    );
  }
), ii = "_callout_b51uq_5", li = "_callout__header_b51uq_19", ri = "_callout__icon_b51uq_26", oi = "_callout__title_b51uq_37", ci = "_callout__content_b51uq_45", X = {
  callout: ii,
  "callout--attention": "_callout--attention_b51uq_12",
  "callout--informative": "_callout--informative_b51uq_15",
  callout__header: li,
  callout__icon: ri,
  "callout__icon--attention": "_callout__icon--attention_b51uq_33",
  callout__title: oi,
  callout__content: ci
}, Co = /* @__PURE__ */ k(
  function({
    children: e,
    className: a,
    innerRef: i,
    intent: l,
    title: r,
    variant: o,
    ...c
  }, _) {
    const s = o || l, d = `callout-title-${we()}`;
    return /* @__PURE__ */ f(
      "aside",
      {
        "aria-labelledby": d,
        className: b(
          X.callout,
          s && X[`callout--${s}`],
          a
        ),
        ref: _ ?? i,
        ...c,
        children: [
          /* @__PURE__ */ f(
            "div",
            {
              className: b(
                X.callout__header,
                s && X[`callout__header--${s}`]
              ),
              children: [
                /* @__PURE__ */ t(
                  Tn,
                  {
                    color: "#EC5409",
                    className: b(
                      X.callout__icon,
                      s && X[`callout__icon--${s}`]
                    )
                  }
                ),
                /* @__PURE__ */ t(
                  "p",
                  {
                    className: b(
                      X.callout__title,
                      s && X[`callout__title--${s}`]
                    ),
                    id: d,
                    children: r
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t("div", { className: X.callout__content, children: e })
        ]
      }
    );
  }
), si = "_callout_olsir_1", di = "_callout__content_olsir_19", Ee = {
  callout: si,
  "callout--success": "_callout--success_olsir_10",
  "callout--danger": "_callout--danger_olsir_14",
  callout__content: di
};
function Io({
  children: n,
  className: e,
  intent: a,
  variant: i,
  ...l
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: b(
        Ee.callout,
        Ee[`callout--${a ?? i}`],
        e
      ),
      ...l,
      children: /* @__PURE__ */ t("div", { className: Ee.callout__content, children: n })
    }
  );
}
const _i = "_flex_rcwev_5", ui = "_align_rcwev_9", pi = "_direction_rcwev_13", mi = "_gap_rcwev_17", hi = "_grow_rcwev_21", bi = "_justify_rcwev_25", q = {
  flex: _i,
  align: ui,
  direction: pi,
  gap: mi,
  grow: hi,
  justify: bi,
  "align-md": "_align-md_rcwev_30",
  "direction-md": "_direction-md_rcwev_33",
  "gap-md": "_gap-md_rcwev_36",
  "grow-md": "_grow-md_rcwev_39",
  "justify-md": "_justify-md_rcwev_42",
  "align-lg": "_align-lg_rcwev_47",
  "direction-lg": "_direction-lg_rcwev_50",
  "gap-lg": "_gap-lg_rcwev_53",
  "grow-lg": "_grow-lg_rcwev_56",
  "justify-lg": "_justify-lg_rcwev_59"
}, gi = "_m_nk770_5", fi = "_mx_nk770_9", yi = "_my_nk770_14", xi = "_mt_nk770_19", vi = "_mr_nk770_23", wi = "_mb_nk770_27", Ni = "_ml_nk770_31", ki = "_p_nk770_85", Ci = "_px_nk770_89", Ii = "_py_nk770_94", $i = "_pt_nk770_99", Pi = "_pr_nk770_103", Si = "_pb_nk770_107", Ri = "_pl_nk770_111", Be = {
  m: gi,
  mx: fi,
  my: yi,
  mt: xi,
  mr: vi,
  mb: wi,
  ml: Ni,
  "m-md": "_m-md_nk770_36",
  "mx-md": "_mx-md_nk770_39",
  "my-md": "_my-md_nk770_43",
  "mt-md": "_mt-md_nk770_47",
  "mr-md": "_mr-md_nk770_50",
  "mb-md": "_mb-md_nk770_53",
  "ml-md": "_ml-md_nk770_56",
  "m-lg": "_m-lg_nk770_61",
  "mx-lg": "_mx-lg_nk770_64",
  "my-lg": "_my-lg_nk770_68",
  "mt-lg": "_mt-lg_nk770_72",
  "mr-lg": "_mr-lg_nk770_75",
  "mb-lg": "_mb-lg_nk770_78",
  "ml-lg": "_ml-lg_nk770_81",
  p: ki,
  px: Ci,
  py: Ii,
  pt: $i,
  pr: Pi,
  pb: Si,
  pl: Ri,
  "p-md": "_p-md_nk770_116",
  "px-md": "_px-md_nk770_119",
  "py-md": "_py-md_nk770_123",
  "pt-md": "_pt-md_nk770_127",
  "pr-md": "_pr-md_nk770_130",
  "pb-md": "_pb-md_nk770_133",
  "pl-md": "_pl-md_nk770_136",
  "p-lg": "_p-lg_nk770_141",
  "px-lg": "_px-lg_nk770_144",
  "py-lg": "_py-lg_nk770_148",
  "pt-lg": "_pt-lg_nk770_152",
  "pr-lg": "_pr-lg_nk770_155",
  "pb-lg": "_pb-lg_nk770_158",
  "pl-lg": "_pl-lg_nk770_161"
}, kt = ["m", "mx", "my", "mt", "mr", "mb", "ml"], Ct = ["p", "px", "py", "pt", "pr", "pb", "pl"], Di = ["md", "lg"];
function Gt(n) {
  const { m: e, mx: a, my: i, mt: l, mr: r, mb: o, ml: c, p: _, px: s, py: d, pt: u, pr: p, pb: h, pl: m } = n;
  return Z(() => {
    const g = {}, y = [];
    return kt.forEach((x) => {
      n[x] && (g[`--sbui-${x}`] = n[x], y.push(Be[x]));
    }), Ct.forEach((x) => {
      n[x] && (g[`--sbui-${x}`] = n[x], y.push(Be[x]));
    }), Di.forEach((x) => {
      kt.forEach((w) => {
        const N = `${x}-${w}`;
        n[N] && (g[`--sbui-${w}-${x}`] = n[N], y.push(Be[`${w}-${x}`]));
      }), Ct.forEach((w) => {
        const N = `${x}-${w}`;
        n[N] && (g[`--sbui-${w}-${x}`] = n[N], y.push(Be[`${w}-${x}`]));
      });
    }), [g, y];
  }, [e, a, i, l, r, o, c, _, s, d, u, p, h, m]);
}
const L = /* @__PURE__ */ k(function({
  asChild: e,
  align: a,
  "md-align": i,
  "lg-align": l,
  className: r,
  direction: o,
  "md-direction": c,
  "lg-direction": _,
  grow: s,
  "md-grow": d,
  "lg-grow": u,
  gap: p,
  "md-gap": h,
  "lg-gap": m,
  justify: g,
  "md-justify": y,
  "lg-justify": x,
  style: w,
  ...N
}, $) {
  const [I, P] = Gt(N), [R, B] = Z(() => {
    const C = [q.flex];
    let v = {};
    return a && (C.push(q.align), v["--sbui-flex-align"] = a), i && (C.push(q["align-md"]), v["--sbui-flex-align-md"] = i), l && (C.push(q["align-lg"]), v["--sbui-flex-align-lg"] = l), o && (C.push(q.direction), v["--sbui-flex-direction"] = o), c && (C.push(q["direction-md"]), v["--sbui-flex-direction-md"] = c), _ && (C.push(q["direction-lg"]), v["--sbui-flex-direction-lg"] = _), p && (C.push(q.gap), v["--sbui-flex-gap"] = p), h && (C.push(q["gap-md"]), v["--sbui-flex-gap-md"] = h), m && (C.push(q["gap-lg"]), v["--sbui-flex-gap-lg"] = m), typeof s == "boolean" && (C.push(q.grow), v["--sbui-flex-grow"] = s ? 1 : "initial"), typeof d == "boolean" && (C.push(q["grow-md"]), v["--sbui-flex-grow-md"] = d ? 1 : "initial"), typeof u == "boolean" && (C.push(q["grow-lg"]), v["--sbui-flex-grow-lg"] = u ? 1 : "initial"), g && (C.push(q.justify), v["--sbui-flex-justify"] = g), y && (C.push(q["justify-md"]), v["--sbui-flex-justify-md"] = y), x && (C.push(q["justify-lg"]), v["--sbui-flex-justify-lg"] = x), w && (v = {
      ...w,
      ...v
    }), [C.concat(r), v];
  }, [
    a,
    i,
    l,
    o,
    c,
    _,
    s,
    d,
    u,
    g,
    y,
    x,
    p,
    h,
    m,
    r,
    w
  ]);
  return /* @__PURE__ */ t(
    e ? me : "div",
    {
      ...N,
      ref: $,
      className: b(...R, ...P),
      style: { ...B, ...I }
    }
  );
}), Ut = ee({
  triggerId: "changeme"
});
function Zt() {
  return H(Ut);
}
const Vi = /* @__PURE__ */ k(
  function(e, a) {
    const i = K(), l = Z(() => ({ triggerId: `${i}-trigger` }), [i]);
    return /* @__PURE__ */ t(Ut.Provider, { value: l, children: /* @__PURE__ */ t(An, { ...e, ref: a }) });
  }
), Bi = /* @__PURE__ */ k(
  function(e, a) {
    const { triggerId: i } = Zt();
    return /* @__PURE__ */ t(
      On,
      {
        ...e,
        id: e.id ?? i,
        ref: a
      }
    );
  }
), Ti = "_animated_1f5b9_1", Fi = "_slideDown_1f5b9_1", Mi = "_slideUp_1f5b9_1", Li = {
  animated: Ti,
  slideDown: Fi,
  slideUp: Mi
}, ji = /* @__PURE__ */ k(
  function({
    animated: e,
    className: a,
    labelled: i,
    region: l,
    style: r,
    ...o
  }, c) {
    const { triggerId: _ } = Zt(), s = (i || l) && !o["aria-label"];
    return /* @__PURE__ */ t(
      Wn,
      {
        ref: c,
        className: b(e && Li.animated, a),
        "aria-labelledby": s ? _ : void 0,
        role: l ? "region" : void 0,
        ...o,
        style: {
          "--sbui-collapsible-content-width": "var(--radix-collapsible-content-width)",
          "--sbui-collapsible-content-height": "var(--radix-collapsible-content-height)",
          ...r
        }
      }
    );
  }
), He = {
  Root: Vi,
  Trigger: Bi,
  Content: ji
}, zi = "_description_1l2we_1", qi = {
  description: zi
};
function Ai({ children: n, className: e, ...a }, i) {
  return /* @__PURE__ */ t("div", { ...a, ref: i, className: b(qi.description, e), children: n });
}
const et = /* @__PURE__ */ k(
  Ai
), Oi = "_label_doyga_5", Wi = "_label__secondary_doyga_14", It = {
  label: Oi,
  label__secondary: Wi
};
function Ei({
  children: n,
  className: e,
  secondaryLabel: a,
  secondaryLabelClassName: i,
  secondaryLabelProps: l = {},
  secondaryLabelRef: r,
  innerRef: o,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: c,
  ..._
}, s) {
  return /* @__PURE__ */ f(
    "label",
    {
      ..._,
      ref: s ?? o,
      className: b(It.label, e),
      children: [
        n,
        /* @__PURE__ */ t(
          "span",
          {
            ...l,
            className: b(It.label__secondary, i),
            ref: r,
            children: a
          }
        )
      ]
    }
  );
}
const Hi = /* @__PURE__ */ k(
  Ei
), Gi = "_label_1yata_1", Ui = {
  label: Gi
};
function Zi({ block: n, ...e }, a) {
  const { children: i, className: l, secondaryLabel: r, innerRef: o, ...c } = e;
  return r ? /* @__PURE__ */ t(Hi, { ...e, secondaryLabel: r }) : /* @__PURE__ */ t(
    "label",
    {
      ...c,
      ref: a ?? o,
      className: b(Ui.label, l),
      children: i
    }
  );
}
const tt = /* @__PURE__ */ k(Zi);
function Ki(n) {
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...n,
      children: [
        /* @__PURE__ */ t("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ t("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" })
      ]
    }
  );
}
function Qi(n) {
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...n,
      children: [
        /* @__PURE__ */ t("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ t("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" })
      ]
    }
  );
}
function Xi(n) {
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...n,
      children: [
        /* @__PURE__ */ t("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ t("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })
      ]
    }
  );
}
const Ji = "_message_1rrtg_1", Yi = "_message__icon_1rrtg_18", le = {
  message: Ji,
  "message--critical": "_message--critical_1rrtg_8",
  "message--warning": "_message--warning_1rrtg_11",
  "message--positive": "_message--positive_1rrtg_14",
  message__icon: Yi
};
function el({ children: n, className: e, tone: a, innerRef: i, ...l }, r) {
  let o = null;
  return a === "critical" && (o = /* @__PURE__ */ t(
    Qi,
    {
      "aria-hidden": !0,
      className: b(
        le.message__icon,
        le["message__icon--critical"]
      )
    }
  )), a === "warning" && (o = /* @__PURE__ */ t(
    Ki,
    {
      "aria-hidden": !0,
      className: b(
        le.message__icon,
        le["message__icon--warning"]
      )
    }
  )), a === "positive" && (o = /* @__PURE__ */ t(
    Xi,
    {
      "aria-hidden": !0,
      className: b(
        le.message__icon,
        le["message__icon--positive"]
      )
    }
  )), /* @__PURE__ */ f(
    "div",
    {
      ...l,
      ref: r ?? i,
      className: b(
        le.message,
        a && le[`message--${a}`],
        e
      ),
      children: [
        o,
        n
      ]
    }
  );
}
const Le = /* @__PURE__ */ k(el);
function tl({
  label: n,
  description: e,
  validationError: a,
  message: i
}, l = {}) {
  const r = K(), o = l.id ?? r, c = l["aria-required"];
  return Z(() => {
    const s = o, d = l.descriptionId ?? `${o}-description`, u = l.labelId ?? `${o}-label`, p = l.validationErrorId ?? `${o}-validation-error`, h = l.messageId ?? `${o}-message`, m = { id: s };
    return n && (m["aria-labelledby"] = u), e && (m["aria-describedby"] = d), i && (m["aria-describedby"] = m["aria-describedby"] ? `${m["aria-describedby"]} ${h}` : h), a && (m["aria-describedby"] = p, m["aria-invalid"] = !0), c && (m["aria-required"] = c), {
      label: {
        id: u,
        htmlFor: s
      },
      description: {
        id: d
      },
      control: m,
      validationError: {
        id: p
      },
      message: {
        id: h
      }
    };
  }, [
    o,
    n,
    e,
    a,
    i,
    c,
    l.labelId,
    l.descriptionId,
    l.messageId,
    l.validationErrorId
  ]);
}
const nl = "_root_19wnc_5", al = "_field_19wnc_27", Te = {
  root: nl,
  field: al,
  "collapsible-trigger": "_collapsible-trigger_19wnc_31",
  "collapsible-content": "_collapsible-content_19wnc_58"
};
function F({ children: n, fallback: e = null, when: a }) {
  return a ? n : e;
}
const te = /* @__PURE__ */ k(
  function({
    "aria-required": e,
    // Prevent block prop from ending up as an attribute on underlying element
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    block: a,
    children: i,
    className: l,
    description: r,
    descriptionProps: o = {},
    contextualHelp: c,
    id: _,
    label: s,
    labelClassName: d,
    labelProps: u = {},
    labelRef: p,
    message: h,
    messageClassName: m,
    messageProps: g = {},
    messageRef: y,
    messageTone: x,
    secondaryLabel: w,
    supplemental: N,
    tone: $,
    validationError: I,
    validationErrorProps: P = {},
    labelId: R,
    descriptionId: B,
    validationErrorId: D,
    messageId: C,
    ...v
  }, j) {
    const V = he(), W = K(), M = r ?? w, z = tl(
      {
        description: M,
        label: s,
        validationError: I,
        message: h && !I
      },
      {
        "aria-required": e,
        id: _,
        labelId: R,
        descriptionId: B,
        validationErrorId: D,
        messageId: C
      }
    ), ae = c ? He.Root : "div", ie = {
      ...c && {
        onOpenChange: (T) => {
          var be;
          return T && ((be = c.onExpand) == null ? void 0 : be.call(c));
        }
      }
    }, de = s || c || M, Q = I || h;
    return /* @__PURE__ */ t(
      L,
      {
        className: Te.field,
        asChild: !0,
        ...v,
        direction: "column",
        gap: ".5rem",
        ref: j,
        children: /* @__PURE__ */ f(
          ae,
          {
            className: b(Te.root, l),
            ...ie,
            children: [
              /* @__PURE__ */ t(F, { when: de, children: /* @__PURE__ */ f("div", { children: [
                /* @__PURE__ */ t(F, { when: s || c, children: /* @__PURE__ */ f(L, { align: "flex-start", justify: "space-between", gap: ".5rem", children: [
                  /* @__PURE__ */ t(
                    tt,
                    {
                      ...z.label,
                      ...u,
                      className: d,
                      ref: p,
                      children: s
                    }
                  ),
                  /* @__PURE__ */ t(F, { when: c, children: /* @__PURE__ */ t(He.Trigger, { asChild: !0, children: /* @__PURE__ */ f(
                    "button",
                    {
                      "aria-label": (c == null ? void 0 : c.title) ?? (V === "en" ? "More information" : "Mer information"),
                      className: Te["collapsible-trigger"],
                      id: W,
                      children: [
                        /* @__PURE__ */ t(Fn, {}),
                        /* @__PURE__ */ t(Mt, {})
                      ]
                    }
                  ) }) })
                ] }) }),
                /* @__PURE__ */ t(F, { when: M, children: /* @__PURE__ */ t(et, { ...z.description, ...o, children: M }) }),
                /* @__PURE__ */ t(F, { when: c, children: /* @__PURE__ */ t(
                  He.Content,
                  {
                    animated: !0,
                    region: !0,
                    "aria-labelledby": W,
                    className: Te["collapsible-content"],
                    children: /* @__PURE__ */ t("div", { children: c == null ? void 0 : c.content })
                  }
                ) })
              ] }) }),
              N,
              /* @__PURE__ */ t("div", { children: i == null ? void 0 : i(z.control, { isInvalid: !!I }) }),
              /* @__PURE__ */ t(F, { when: Q, children: /* @__PURE__ */ f("div", { children: [
                /* @__PURE__ */ t(F, { when: I, children: /* @__PURE__ */ t(
                  Le,
                  {
                    ...z.validationError,
                    ...P,
                    tone: "critical",
                    children: I
                  }
                ) }),
                /* @__PURE__ */ t(F, { when: h && !I, children: /* @__PURE__ */ t(
                  Le,
                  {
                    ...z.message,
                    ...g,
                    ref: y,
                    className: m,
                    tone: x ?? $,
                    children: h
                  }
                ) })
              ] }) })
            ]
          }
        )
      }
    );
  }
), il = "_grid_17w5t_5", ll = "_columns_17w5t_9", rl = "_gap_17w5t_13", ol = "_place_17w5t_25", A = {
  grid: il,
  columns: ll,
  gap: rl,
  "gap-x": "_gap-x_17w5t_17",
  "gap-y": "_gap-y_17w5t_21",
  place: ol,
  "columns-md": "_columns-md_17w5t_30",
  "gap-md": "_gap-md_17w5t_33",
  "gap-x-md": "_gap-x-md_17w5t_36",
  "gap-y-md": "_gap-y-md_17w5t_39",
  "place-md": "_place-md_17w5t_42",
  "columns-lg": "_columns-lg_17w5t_47",
  "gap-lg": "_gap-lg_17w5t_50",
  "gap-x-lg": "_gap-x-lg_17w5t_53",
  "gap-y-lg": "_gap-y-lg_17w5t_56",
  "place-lg": "_place-lg_17w5t_59"
}, $o = /* @__PURE__ */ k(function({
  asChild: e,
  className: a,
  columns: i,
  "md-columns": l,
  "lg-columns": r,
  gap: o,
  "md-gap": c,
  "lg-gap": _,
  "gap-x": s,
  "md-gap-x": d,
  "lg-gap-x": u,
  "gap-y": p,
  "md-gap-y": h,
  "lg-gap-y": m,
  place: g,
  "md-place": y,
  "lg-place": x,
  style: w,
  ...N
}, $) {
  const [I, P] = Gt(N), [R, B] = Z(() => {
    const C = [A.grid];
    let v = {};
    return i && (C.push(A.columns), v["--sbui-grid-columns"] = i), l && (C.push(A["columns-md"]), v["--sbui-grid-columns-md"] = l), r && (C.push(A["columns-lg"]), v["--sbui-grid-columns-lg"] = r), o && (C.push(A.gap), v["--sbui-grid-gap"] = o), c && (C.push(A["gap-md"]), v["--sbui-grid-gap-md"] = c), _ && (C.push(A["gap-lg"]), v["--sbui-grid-gap-lg"] = _), s && (C.push(A["gap-x"]), v["--sbui-grid-gap-x"] = s), d && (C.push(A["gap-x-md"]), v["--sbui-grid-gap-x-md"] = d), u && (C.push(A["gap-x-lg"]), v["--sbui-grid-gap-x-lg"] = u), p && (C.push(A["gap-y"]), v["--sbui-grid-gap-y"] = p), h && (C.push(A["gap-y-md"]), v["--sbui-grid-gap-y-md"] = h), m && (C.push(A["gap-y-lg"]), v["--sbui-grid-gap-y-lg"] = m), g && (C.push(A.place), v["--sbui-grid-place"] = g), y && (C.push(A["place-md"]), v["--sbui-grid-place-md"] = y), x && (C.push(A["place-lg"]), v["--sbui-grid-place-lg"] = x), w && (v = {
      ...w,
      ...v
    }), [C.concat(a), v];
  }, [
    a,
    i,
    l,
    r,
    o,
    c,
    _,
    s,
    d,
    u,
    p,
    h,
    m,
    g,
    y,
    x,
    w
  ]);
  return /* @__PURE__ */ t(
    e ? me : "div",
    {
      ...N,
      ref: $,
      className: b(...R, ...P),
      style: { ...B, ...I }
    }
  );
}), cl = "_spacer_krim3_5", sl = "_hidden_krim3_9", ge = {
  spacer: cl,
  hidden: sl,
  "hidden-md": "_hidden-md_krim3_14",
  "visible-md": "_visible-md_krim3_17",
  "hidden-lg": "_hidden-lg_krim3_22",
  "visible-lg": "_visible-lg_krim3_25"
};
function Po({
  className: n,
  hidden: e,
  "md-hidden": a,
  "lg-hidden": i,
  style: l
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      "aria-hidden": !0,
      className: b(
        ge.spacer,
        e && ge.hidden,
        a === !0 && ge["hidden-md"],
        a === !1 && ge["visible-md"],
        i === !0 && ge["hidden-lg"],
        i === !1 && ge["visible-lg"],
        n
      ),
      style: l
    }
  );
}
function So(n) {
  return /* @__PURE__ */ t(L, { ...n, direction: "column", align: "flex-start" });
}
const dl = "_item_g5kc2_5", _l = "_indicator_g5kc2_13", ul = "_label_g5kc2_30", nt = {
  item: dl,
  indicator: _l,
  label: ul
};
function pl(n) {
  const e = O(typeof n < "u");
  return typeof n < "u" && !e.current && (e.current = !0), e.current;
}
function se(n, e, a) {
  const i = pl(n), [l, r] = Se(e);
  let o = i ? n : l;
  return i && typeof n > "u" && (o = a), [o, r];
}
const at = ee({}), it = ee({});
function Kt({
  children: n,
  defaultValue: e = [],
  disabled: a,
  name: i,
  onBlur: l,
  onChange: r,
  onFocus: o,
  value: c,
  ..._
}) {
  const [s, d] = se(
    c,
    e ?? [],
    []
  ), u = s, p = ce(
    (g) => {
      const { checked: y, value: x } = g.target, w = y ? [...u, x] : u.filter((N) => N !== x);
      d(w), r == null || r(w);
    },
    [r, u, d]
  ), h = K(), { focusWithinProps: m } = zt({
    onBlurWithin: l,
    onFocusWithin: o
  });
  return /* @__PURE__ */ t(
    at.Provider,
    {
      value: {
        disabled: a,
        handleChange: p,
        name: i ?? h,
        selectedValues: u
      },
      children: /* @__PURE__ */ t("div", { ..._, ...m, role: "group", children: n })
    }
  );
}
const lt = /* @__PURE__ */ k(
  function(e, a) {
    const { handleChange: i } = H(at);
    return i ? /* @__PURE__ */ t(ml, { ...e, inputRef: a }) : /* @__PURE__ */ t(hl, { ...e, inputRef: a });
  }
);
function ml({
  disabled: n,
  value: e,
  ...a
}) {
  const {
    disabled: i,
    handleChange: l,
    name: r,
    selectedValues: o
  } = H(at), c = (e ? o == null ? void 0 : o.includes(e) : !1) ?? !1;
  return /* @__PURE__ */ t(
    Qt,
    {
      ...a,
      checked: c,
      disabled: i ?? n,
      name: r,
      onChange: l,
      value: e
    }
  );
}
function hl({
  checked: n,
  defaultChecked: e = !1,
  onChange: a,
  ...i
}) {
  const [l, r] = Se(e), o = ce(
    (_) => {
      r(_.target.checked), a == null || a(_.target.checked);
    },
    [a, r]
  );
  return /* @__PURE__ */ t(Qt, { ...i, checked: typeof n < "u" ? n : l, onChange: o });
}
function Qt({
  "aria-labelledby": n,
  children: e,
  className: a,
  checked: i,
  disabled: l,
  inputRef: r,
  name: o,
  onBlur: c,
  onChange: _,
  onFocus: s,
  style: d,
  value: u
}) {
  const p = K(), h = `${p}-control`, m = `${p}-label`;
  let g = m;
  return n && (g += ` ${n}`), /* @__PURE__ */ t(it.Provider, { value: { controlId: h, isChecked: i, labelId: m, value: u }, children: /* @__PURE__ */ f(
    "label",
    {
      "data-disabled": l,
      className: b(nt.item, a),
      style: d,
      children: [
        /* @__PURE__ */ t(Y, { children: /* @__PURE__ */ t(
          "input",
          {
            type: "checkbox",
            "aria-labelledby": g,
            checked: i,
            disabled: l,
            id: h,
            name: o,
            onBlur: c,
            onChange: _,
            onFocus: s,
            ref: r,
            value: u
          }
        ) }),
        typeof e == "function" ? e == null ? void 0 : e({ isChecked: i ?? !1, isDisabled: l }) : e
      ]
    }
  ) });
}
function rt({ className: n }) {
  const { isChecked: e } = H(it);
  return /* @__PURE__ */ f(
    "svg",
    {
      "aria-hidden": !0,
      width: "1.125rem",
      height: "1.125rem",
      viewBox: "0 0 18 18",
      className: b(nt.indicator, n),
      children: [
        /* @__PURE__ */ t("rect", { x: 0.5, y: 0.5, width: 17, height: 17 }),
        e && /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.083 4.91699L7.83301 10.167L5.79134 8.12533L4.33301 9.58366L7.83301 13.0837L14.5413 6.37533L13.083 4.91699Z"
          }
        )
      ]
    }
  );
}
function ot({ children: n, className: e }) {
  const { labelId: a } = H(it);
  return /* @__PURE__ */ t("span", { className: b(nt.label, e), id: a, children: n });
}
const Ge = {
  "standalone-root": "_standalone-root_82v7u_1",
  "standalone-indicator": "_standalone-indicator_82v7u_4",
  "standalone-label": "_standalone-label_82v7u_9"
}, bl = /* @__PURE__ */ k(
  function({ label: e, className: a, ...i }, l) {
    return /* @__PURE__ */ t(
      lt,
      {
        ...i,
        className: b(Ge["standalone-root"], a),
        ref: l,
        children: /* @__PURE__ */ f(L, { align: "flex-start", gap: ".5rem", children: [
          /* @__PURE__ */ t(rt, { className: Ge["standalone-indicator"] }),
          /* @__PURE__ */ t(ot, { className: Ge["standalone-label"], children: e })
        ] })
      }
    );
  }
), Ue = {
  "standard-item": "_standard-item_16gxn_1",
  "standard-indicator": "_standard-indicator_16gxn_4",
  "standard-label": "_standard-label_16gxn_9"
}, gl = /* @__PURE__ */ k(function({
  className: e,
  defaultValue: a,
  name: i,
  onBlur: l,
  onChange: r,
  onFocus: o,
  options: c,
  value: _,
  ...s
}, d) {
  return /* @__PURE__ */ t(te, { ...s, className: e, children: (u) => /* @__PURE__ */ t(
    Kt,
    {
      ...u,
      defaultValue: a,
      name: i,
      onBlur: l,
      onChange: r,
      onFocus: o,
      value: _,
      children: /* @__PURE__ */ t(L, { direction: "column", gap: ".5rem", children: c.map((p, h) => /* @__PURE__ */ t(
        lt,
        {
          className: Ue["standard-item"],
          value: p.value,
          ref: h ? void 0 : d,
          children: /* @__PURE__ */ f(L, { align: "flex-start", gap: ".5rem", children: [
            /* @__PURE__ */ t(rt, { className: Ue["standard-indicator"] }),
            /* @__PURE__ */ t(ot, { className: Ue["standard-label"], children: p.label })
          ] })
        },
        p.value
      )) })
    }
  ) });
}), fl = "_checkbox__input_alq2y_5", yl = "_checkbox__label_alq2y_10", $t = {
  checkbox__input: fl,
  checkbox__label: yl
}, Xt = ee(null), xl = /* @__PURE__ */ k(
  function({
    checked: e,
    className: a,
    defaultChecked: i,
    disabled: l = !1,
    id: r,
    innerRef: o,
    inputClassName: c,
    inputProps: _ = {},
    inputRef: s,
    label: d,
    labelClassName: u,
    labelProps: p = {},
    labelRef: h,
    name: m,
    onBlur: g,
    onChange: y,
    onFocus: x,
    value: w,
    ...N
  }, $) {
    var C;
    const I = H(Xt), P = ce(
      (v) => {
        y && y(v), I != null && I.onChange && I.onChange(v);
      },
      [y, I == null ? void 0 : I.onChange]
    ), R = `checkbox-${we()}`, B = r ?? R;
    let D = e;
    return I != null && I.values && (D = ((C = I.values) == null ? void 0 : C.indexOf(w)) > -1), /* @__PURE__ */ f(
      "div",
      {
        ...N,
        ref: $ ?? o,
        className: a,
        onClick: (v) => {
          v.target.localName === "input" && v.target.focus(), typeof N.onClick == "function" && N.onClick(v);
        },
        children: [
          /* @__PURE__ */ t(
            "input",
            {
              ..._,
              checked: D,
              className: b($t.checkbox__input, c),
              defaultChecked: i,
              disabled: l,
              id: B,
              name: m ?? (I == null ? void 0 : I.name),
              onBlur: g,
              onChange: P,
              onFocus: x,
              ref: s,
              type: "checkbox",
              value: w
            }
          ),
          /* @__PURE__ */ t(
            "label",
            {
              ...p,
              htmlFor: B,
              ref: h,
              className: b($t.checkbox__label, u),
              children: d
            }
          )
        ]
      }
    );
  }
), Pt = {
  "checkbox-group--row": "_checkbox-group--row_e7s4j_1"
};
function vl({
  children: n,
  description: e,
  label: a,
  message: i,
  name: l,
  onChange: r,
  row: o,
  secondaryLabel: c,
  supplemental: _,
  tone: s,
  values: d = [],
  ...u
}) {
  const p = we(), h = `label-${p}`, m = `description-${p}`, g = `message-${p}`, y = ce(
    (N) => {
      if (r) {
        const { value: $ } = N.currentTarget, I = d.indexOf($);
        I > -1 ? r(d.filter((P, R) => R !== I)) : r([...d, $]);
      }
    },
    [r, d]
  ), x = Z(
    () => ({
      name: l,
      onChange: y,
      values: d ?? []
    }),
    [l, y, d]
  );
  let w;
  return (i || e) && (w = [e && m, i && g].filter(Boolean).join(" ")), /* @__PURE__ */ f(L, { ...u, direction: "column", gap: "0.5rem", children: [
    a && /* @__PURE__ */ f("div", { children: [
      /* @__PURE__ */ t(
        tt,
        {
          id: h,
          secondaryLabel: e ? void 0 : c,
          children: a
        }
      ),
      typeof e < "u" && /* @__PURE__ */ t(et, { id: m, children: e })
    ] }),
    _,
    /* @__PURE__ */ t(Xt.Provider, { value: x, children: /* @__PURE__ */ t(
      "div",
      {
        role: "group",
        "aria-labelledby": h,
        "aria-describedby": w,
        "aria-invalid": s === "critical",
        className: b(
          Pt["checkbox-group"],
          o && Pt["checkbox-group--row"]
        ),
        children: n
      }
    ) }),
    i && /* @__PURE__ */ t(Le, { id: g, tone: s, children: i })
  ] });
}
const qe = xl;
qe.Root = lt;
qe.Indicator = rt;
qe.Label = ot;
qe.Standalone = bl;
const Jt = vl;
Jt.Root = Kt;
Jt.Standard = gl;
function Yt({ children: n }) {
  const e = he();
  return /* @__PURE__ */ t(En, { locale: ct(e), children: n });
}
function ct(n) {
  return n === "en" ? "en-GB" : "sv-SE";
}
const wl = "_group_1w4ol_5", Nl = "_field_1w4ol_56", kl = "_segments_1w4ol_75", Cl = "_segment_1w4ol_75", Il = "_dialog_1w4ol_101", $l = "_calendar_1w4ol_23", S = {
  group: wl,
  "calendar-trigger-button": "_calendar-trigger-button_1w4ol_23",
  "single-field-wrapper": "_single-field-wrapper_1w4ol_45",
  "range-field-wrapper": "_range-field-wrapper_1w4ol_46",
  field: Nl,
  "range-separator--empty": "_range-separator--empty_1w4ol_63",
  segments: kl,
  segment: Cl,
  dialog: Il,
  calendar: $l,
  "calendar-header": "_calendar-header_1w4ol_120",
  "calendar-title": "_calendar-title_1w4ol_127",
  "calendar-direction-button": "_calendar-direction-button_1w4ol_133",
  "calendar-grids": "_calendar-grids_1w4ol_154",
  "calendar-grid": "_calendar-grid_1w4ol_154",
  "calendar-cell": "_calendar-cell_1w4ol_182",
  "calendar-cell--within-selection": "_calendar-cell--within-selection_1w4ol_187",
  "calendar-cell--selection-start": "_calendar-cell--selection-start_1w4ol_190",
  "calendar-cell--selection-end": "_calendar-cell--selection-end_1w4ol_194",
  "calendar-cell-button": "_calendar-cell-button_1w4ol_199",
  "calendar-cell-button--selectable": "_calendar-cell-button--selectable_1w4ol_211",
  "calendar-cell-button--highlighted": "_calendar-cell-button--highlighted_1w4ol_218",
  "calendar-cell-button--outside-visible-range": "_calendar-cell-button--outside-visible-range_1w4ol_222",
  "calendar-cell-button--unavailable": "_calendar-cell-button--unavailable_1w4ol_225",
  "calendar-cell-button--disabled": "_calendar-cell-button--disabled_1w4ol_225"
};
function st(n) {
  switch (n) {
    case "gregory":
      return new oa();
    default:
      throw new Error(`Unsupported calendar: ${n}`);
  }
}
function Qe({ isRange: n, ...e }) {
  const { locale: a } = Ye(), [i, l] = Se(""), r = _a({
    ...e,
    locale: a,
    createCalendar: st
  }), o = O(null), { fieldProps: c } = Hn(e, r, o), _ = r.value;
  return pe(() => {
    if (_) {
      const s = _.year.toString().padStart(4, "0"), d = _.month.toString().padStart(2, "0"), u = _.day.toString().padStart(2, "0");
      l(`${s}-${d}-${u}`);
    } else
      l("");
  }, [_, l]), /* @__PURE__ */ f("div", { className: S.field, children: [
    /* @__PURE__ */ t(
      "div",
      {
        ...c,
        ref: o,
        className: b(S.segments, n && S["segments--range"]),
        children: r.segments.map((s, d) => /* @__PURE__ */ t(Pl, { segment: s, state: r }, d))
      }
    ),
    /* @__PURE__ */ t("input", { type: "hidden", name: e.name, readOnly: !0, value: i })
  ] });
}
function Pl({ segment: n, state: e }) {
  const a = O(null), { segmentProps: i } = Gn(n, e, a);
  return /* @__PURE__ */ t(
    "div",
    {
      ...i,
      autoCapitalize: "none",
      ref: a,
      className: S.segment,
      children: n.text
    }
  );
}
function en({ className: n, ...e }) {
  const a = O(null), { buttonProps: i } = qt(e, a);
  return /* @__PURE__ */ t("button", { ...i, className: n, ref: a, children: e.children });
}
function tn(n) {
  return /* @__PURE__ */ t(en, { ...n, className: S["calendar-trigger-button"], children: /* @__PURE__ */ t(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M21 3H18V1H16V3H8V1H6V3H3V21H21V3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z",
          fill: "currentColor"
        }
      )
    }
  ) });
}
function nn({ children: n, state: e, ...a }) {
  const i = O(null), { popoverProps: l, underlayProps: r } = Un(
    {
      ...a,
      popoverRef: i
    },
    e
  );
  return /* @__PURE__ */ f(Zn, { children: [
    /* @__PURE__ */ t("div", { ...r, style: { position: "fixed", inset: 0 } }),
    /* @__PURE__ */ f("div", { ...l, ref: i, children: [
      /* @__PURE__ */ t(yt, { onDismiss: e.close }),
      n,
      /* @__PURE__ */ t(yt, { onDismiss: e.close })
    ] })
  ] });
}
function an({ title: n, children: e, ...a }) {
  const i = O(null), { dialogProps: l, titleProps: r } = Kn(a, i);
  return /* @__PURE__ */ f("div", { ...l, ref: i, className: S.dialog, children: [
    /* @__PURE__ */ t(F, { when: n, children: /* @__PURE__ */ t("h3", { ...r, style: { marginTop: 0 }, children: n }) }),
    e
  ] });
}
function je(n) {
  return /* @__PURE__ */ t(
    en,
    {
      ...n,
      className: S["calendar-direction-button"]
    }
  );
}
function Sl({ ...n }) {
  const { locale: e } = Ye(), a = ua({
    ...n,
    locale: e,
    createCalendar: st
  }), { calendarProps: i, prevButtonProps: l, nextButtonProps: r, title: o } = Qn(n, a);
  return /* @__PURE__ */ f("div", { ...i, className: S.calendar, children: [
    /* @__PURE__ */ f("div", { className: S["calendar-header"], children: [
      /* @__PURE__ */ t(je, { ...l, children: /* @__PURE__ */ t(Lt, { size: "1rem" }) }),
      /* @__PURE__ */ t("h2", { className: S["calendar-title"], children: o }),
      /* @__PURE__ */ t(je, { ...r, children: /* @__PURE__ */ t(jt, { size: "1rem" }) })
    ] }),
    /* @__PURE__ */ t(ln, { locale: e, state: a, weekdayStyle: "short" })
  ] });
}
function Rl({
  visibleMonthCount: n = 1,
  ...e
}) {
  const { locale: a } = Ye(), i = pa({
    ...e,
    locale: a,
    createCalendar: st,
    visibleDuration: { months: n }
  }), l = O(null), { calendarProps: r, prevButtonProps: o, nextButtonProps: c, title: _ } = Xn(e, i, l);
  return /* @__PURE__ */ f("div", { ...r, className: S.calendar, children: [
    /* @__PURE__ */ f("div", { className: S["calendar-header"], children: [
      /* @__PURE__ */ t(je, { ...o, children: /* @__PURE__ */ t(Lt, { size: "1rem" }) }),
      /* @__PURE__ */ t("h2", { className: S["calendar-title"], children: _ }),
      /* @__PURE__ */ t(je, { ...c, children: /* @__PURE__ */ t(jt, { size: "1rem" }) })
    ] }),
    /* @__PURE__ */ t("div", { className: S["calendar-grids"], children: Array.from({ length: n }).map((s, d) => /* @__PURE__ */ t(
      ln,
      {
        locale: a,
        state: i,
        weekdayStyle: "short",
        offset: d ? { months: d } : void 0
      },
      d
    )) })
  ] });
}
function ln({
  locale: n,
  offset: e = {},
  state: a,
  ...i
}) {
  const l = a.visibleRange.start.add(e), r = ca(l), { gridProps: o, headerProps: c, weekDays: _ } = Jn(
    {
      ...i,
      startDate: l,
      endDate: r
    },
    a
  ), s = sa(l, n);
  return /* @__PURE__ */ f("table", { ...o, cellPadding: 0, className: S["calendar-grid"], children: [
    /* @__PURE__ */ t("thead", { ...c, children: /* @__PURE__ */ t("tr", { children: _.map((d, u) => /* @__PURE__ */ t("th", { children: d }, u)) }) }),
    /* @__PURE__ */ t("tbody", { children: Array.from({ length: s }).map((d, u) => /* @__PURE__ */ t("tr", { children: a.getDatesInWeek(u, l).map(
      (p, h) => p ? /* @__PURE__ */ t(
        Dl,
        {
          date: p,
          state: a,
          currentMonth: l
        },
        h
      ) : /* @__PURE__ */ t("td", {}, h)
    ) }, u)) })
  ] });
}
function Dl({ currentMonth: n, date: e, state: a }) {
  const i = O(null), {
    cellProps: l,
    buttonProps: r,
    isSelected: o,
    isOutsideVisibleRange: c,
    isDisabled: _,
    isUnavailable: s,
    formattedDate: d
  } = Yn({ date: e }, a, i), u = !da(n, e), p = !_ && !c && !s && !u;
  let h = o, m = !1, g = !1, y = !1;
  return "highlightedRange" in a && a.highlightedRange && (m = xt(e, a.highlightedRange.start), g = xt(e, a.highlightedRange.end), y = o && !u, y && !(m || g) && (h = !1)), /* @__PURE__ */ t(
    "td",
    {
      ...l,
      className: b(
        S["calendar-cell"],
        y && S["calendar-cell--within-selection"],
        m && S["calendar-cell--selection-start"],
        g && S["calendar-cell--selection-end"]
      ),
      children: /* @__PURE__ */ t(
        "div",
        {
          ...r,
          ref: i,
          className: b(
            S["calendar-cell-button"],
            h && S["calendar-cell-button--highlighted"],
            (c || u) && S["calendar-cell-button--outside-visible-range"],
            _ && S["calendar-cell-button--disabled"],
            s && S["calendar-cell-button--unavailable"],
            p && S["calendar-cell-button--selectable"]
          ),
          children: d
        }
      )
    }
  );
}
const Ro = /* @__PURE__ */ k(
  function({
    "aria-label": e,
    "aria-required": a,
    defaultValue: i,
    description: l,
    descriptionProps: r = {},
    isDateAvailable: o,
    label: c,
    labelProps: _ = {},
    message: s,
    messageProps: d,
    messageTone: u,
    min: p,
    max: h,
    name: m,
    onBlur: g,
    onChange: y,
    validationError: x,
    validationErrorProps: w,
    value: N,
    ...$
  }, I) {
    const P = i ? G(i) : void 0, R = N ? G(N) : void 0, [B, D] = se(
      R,
      P ?? null,
      null
    ), C = p ? G(p) : void 0, v = h ? G(h) : void 0, j = ma({
      isInvalid: !!x || u === "critical",
      minValue: C,
      maxValue: v,
      onChange: (T) => {
        T ? (D(T), y == null || y(T == null ? void 0 : T.toString())) : (D(null), y == null || y(void 0));
      },
      value: B
    }), V = O(null), {
      groupProps: W,
      labelProps: M,
      descriptionProps: z,
      fieldProps: ae,
      buttonProps: ie,
      dialogProps: de,
      calendarProps: Q
    } = ea(
      {
        "aria-label": e,
        isDateUnavailable: o ? (T) => !o(T) : void 0,
        isRequired: a === !0 || a === "true" ? !0 : void 0,
        validationBehavior: "aria",
        minValue: C,
        maxValue: v,
        description: x ?? s,
        onBlur: g,
        label: c,
        name: m
      },
      j,
      V
    );
    return ve(
      I,
      () => ({
        // `ref.focus()` is used by form libraries like `react-hook-form`
        // in order to focus an element upon validation errors etc.
        focus() {
          var T;
          V.current && ((T = V.current.querySelector(
            '[role="spinbutton"]'
          )) == null || T.focus());
        }
      }),
      []
    ), /* @__PURE__ */ t(Yt, { children: /* @__PURE__ */ t(
      te,
      {
        ...$,
        label: c,
        labelProps: { ..._, ...M },
        labelId: M.id,
        description: l,
        descriptionProps: { ...r, ...z },
        descriptionId: z.id,
        message: s,
        messageProps: d,
        messageTone: u,
        validationError: x,
        validationErrorProps: w,
        children: (T) => /* @__PURE__ */ f(ue, { children: [
          /* @__PURE__ */ f(
            "div",
            {
              ...W,
              ...T,
              ref: V,
              className: S.group,
              "data-invalid": j.isInvalid ? "true" : void 0,
              children: [
                /* @__PURE__ */ t("div", { className: S["single-field-wrapper"], children: /* @__PURE__ */ t(Qe, { ...ae }) }),
                /* @__PURE__ */ t(tn, { ...ie })
              ]
            }
          ),
          /* @__PURE__ */ t(F, { when: j.isOpen, children: /* @__PURE__ */ t(
            nn,
            {
              state: j,
              triggerRef: V,
              placement: "bottom start",
              offset: 8,
              children: /* @__PURE__ */ t(an, { ...de, children: /* @__PURE__ */ t(Sl, { ...Q }) })
            }
          ) })
        ] })
      }
    ) });
  }
), Do = /* @__PURE__ */ k(
  function({
    "aria-label": e,
    "aria-required": a,
    defaultValue: i,
    description: l,
    descriptionProps: r = {},
    label: o,
    labelProps: c = {},
    message: _,
    messageProps: s,
    messageTone: d,
    min: u,
    max: p,
    startName: h,
    endName: m,
    onBlur: g,
    onChange: y,
    validationError: x,
    validationErrorProps: w,
    value: N,
    visibleMonthCount: $,
    ...I
  }, P) {
    var Ne, Ve;
    const R = i ? {
      start: G(i.start),
      end: G(i.end)
    } : void 0, B = N ? {
      start: G(N.start),
      end: G(N.end)
    } : void 0, [D, C] = se(
      B,
      R ?? null,
      null
    ), v = u ? G(u) : void 0, j = p ? G(p) : void 0, V = ha({
      isInvalid: !!x || d === "critical",
      minValue: v,
      maxValue: j,
      onChange: (E) => {
        E ? (C(E), y == null || y({
          start: E.start.toString(),
          end: E.end.toString()
        })) : (C(null), y == null || y(void 0));
      },
      value: D
    }), W = O(null), {
      groupProps: M,
      labelProps: z,
      descriptionProps: ae,
      startFieldProps: ie,
      endFieldProps: de,
      buttonProps: Q,
      dialogProps: T,
      calendarProps: be
    } = ta(
      {
        "aria-label": e,
        isRequired: a === !0 || a === "true" ? !0 : void 0,
        validationBehavior: "aria",
        minValue: v,
        maxValue: j,
        description: x ?? _,
        onBlur: g,
        label: o,
        startName: h,
        endName: m
      },
      V,
      W
    );
    ve(
      P,
      () => ({
        // `ref.focus()` is used by form libraries like `react-hook-form`
        // in order to focus an element upon validation errors etc.
        focus() {
          var E;
          W.current && ((E = W.current.querySelector(
            '[role="spinbutton"]'
          )) == null || E.focus());
        }
      }),
      []
    );
    const De = !!((Ne = V.value) != null && Ne.start || (Ve = V.value) != null && Ve.end);
    return /* @__PURE__ */ t(Yt, { children: /* @__PURE__ */ t(
      te,
      {
        ...I,
        label: o,
        labelProps: { ...c, ...z },
        labelId: z.id,
        description: l,
        descriptionProps: { ...r, ...ae },
        descriptionId: ae.id,
        message: _,
        messageProps: s,
        messageTone: d,
        validationError: x,
        validationErrorProps: w,
        children: (E) => /* @__PURE__ */ f(ue, { children: [
          /* @__PURE__ */ f(
            "div",
            {
              ...M,
              ...E,
              ref: W,
              className: S.group,
              "data-invalid": V.isInvalid ? "true" : void 0,
              children: [
                /* @__PURE__ */ f("div", { className: S["range-field-wrapper"], children: [
                  /* @__PURE__ */ t(Qe, { ...ie, isRange: !0 }),
                  /* @__PURE__ */ t(
                    "span",
                    {
                      className: b(
                        S["range-separator"],
                        !De && S["range-separator--empty"]
                      ),
                      children: "–"
                    }
                  ),
                  /* @__PURE__ */ t(Qe, { ...de, isRange: !0 })
                ] }),
                /* @__PURE__ */ t(tn, { ...Q })
              ]
            }
          ),
          /* @__PURE__ */ t(F, { when: V.isOpen, children: /* @__PURE__ */ t(
            nn,
            {
              state: V,
              triggerRef: W,
              placement: "bottom start",
              offset: 8,
              children: /* @__PURE__ */ t(an, { ...T, children: /* @__PURE__ */ t(
                Rl,
                {
                  ...be,
                  visibleMonthCount: $
                }
              ) })
            }
          ) })
        ] })
      }
    ) });
  }
), Vl = "_exclamationSpinner_1ym0y_1", Bl = "_exclamationSpinnerCircle_1ym0y_5", Tl = "_circle_animation_1ym0y_1", Fl = "_exclamationSpinnerRect_1ym0y_12", Ml = "_rect_animation_1ym0y_1", Ze = {
  exclamationSpinner: Vl,
  exclamationSpinnerCircle: Bl,
  circle_animation: Tl,
  exclamationSpinnerRect: Fl,
  rect_animation: Ml
};
function Ll({ className: n, ...e }, a) {
  return /* @__PURE__ */ f(
    "svg",
    {
      ...e,
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      className: b(Ze.exclamationSpinner, n),
      viewBox: "100 100 300 300",
      xmlns: "http://www.w3.org/2000/svg",
      ref: a,
      children: [
        /* @__PURE__ */ t(
          "rect",
          {
            className: Ze.exclamationSpinnerRect,
            x: "220",
            y: "200",
            width: "50",
            height: "190"
          }
        ),
        /* @__PURE__ */ t(
          "circle",
          {
            className: Ze.exclamationSpinnerCircle,
            cx: "245",
            cy: "140",
            r: "30"
          }
        )
      ]
    }
  );
}
const Vo = /* @__PURE__ */ k(
  Ll
), jl = "_informationCard_15bxt_1", zl = "_title_15bxt_46", ql = "_body_15bxt_50", Al = "_footer_15bxt_53", Ce = {
  informationCard: jl,
  "informationCard--information": "_informationCard--information_15bxt_14",
  "informationCard--warning": "_informationCard--warning_15bxt_22",
  "informationCard--positive": "_informationCard--positive_15bxt_30",
  "informationCard--critical": "_informationCard--critical_15bxt_38",
  title: zl,
  body: ql,
  footer: Al
}, Ol = {
  information: Mn,
  warning: Ln,
  positive: jn,
  critical: zn
}, Wl = (n) => /* @__PURE__ */ t(ni, { external: n.external, href: n.href, children: n.label }, n.key), El = /* @__PURE__ */ k(
  ({
    "aria-labelledby": n,
    children: e,
    className: a,
    footerLinks: i,
    renderFooterLink: l = Wl,
    role: r,
    title: o,
    variant: c = "information",
    ..._
  }, s) => {
    const d = Ol[c], u = K();
    let p = n;
    return r && o && !p && (p = u), /* @__PURE__ */ f(
      "div",
      {
        ..._,
        "aria-labelledby": p,
        className: b(
          Ce.informationCard,
          c && Ce[`informationCard--${c}`],
          a
        ),
        ref: s,
        role: r,
        children: [
          d && /* @__PURE__ */ t(d, { size: "1.5rem", "aria-hidden": "true" }),
          /* @__PURE__ */ f(L, { direction: "column", gap: "0.25rem", children: [
            o && /* @__PURE__ */ t("span", { className: Ce.title, id: u, children: o }),
            /* @__PURE__ */ t("div", { className: Ce.body, children: e }),
            i && /* @__PURE__ */ t("div", { className: Ce.footer, children: i.map(
              (h, m, g) => l({ ...h, key: h.href }, m, g)
            ) })
          ] })
        ]
      }
    );
  }
);
El.displayName = "InformationCard";
const Hl = "_input_7kohu_5", Ie = {
  input: Hl,
  "input--invalid": "_input--invalid_7kohu_33",
  "input--large": "_input--large_7kohu_36",
  "input--small": "_input--small_7kohu_41"
};
function Gl({
  className: n,
  invalid: e = !1,
  innerRef: a,
  type: i = "text",
  size: l,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: r,
  ...o
}, c) {
  return /* @__PURE__ */ t(
    "input",
    {
      ...o,
      "aria-invalid": e ? !0 : void 0,
      type: i,
      ref: c ?? a,
      className: b(
        Ie.input,
        l && Ie[`input--${l}`],
        e && Ie["input--invalid"],
        n
      )
    }
  );
}
const Ul = /* @__PURE__ */ k(Gl), Zl = /* @__PURE__ */ k(
  function({
    "aria-label": e,
    "aria-labelledby": a,
    "aria-describedby": i,
    "aria-required": l,
    className: r,
    defaultValue: o,
    disabled: c,
    formatOptions: _,
    id: s,
    invalid: d,
    min: u,
    max: p,
    name: h,
    onBlur: m,
    onChange: g,
    onFocus: y,
    placeholder: x,
    step: w,
    value: N,
    ...$
  }, I) {
    const P = he(), [R, B] = se(
      N,
      o ?? NaN,
      NaN
    ), D = (V) => {
      B(V), g == null || g(Number.isNaN(V) ? void 0 : V);
    }, C = Ot({
      formatOptions: _,
      isDisabled: c,
      isInvalid: d,
      locale: ct(P),
      minValue: u,
      maxValue: p,
      onBlur: m,
      onChange: D,
      onFocus: y,
      placeholder: x,
      step: w,
      value: R
    }), v = O(null);
    ve(I, () => v.current);
    const { inputProps: j } = At(
      {
        "aria-label": e,
        "aria-labelledby": a,
        "aria-describedby": i,
        formatOptions: _,
        id: s,
        isDisabled: c,
        isInvalid: d,
        minValue: u,
        maxValue: p,
        onBlur: m,
        onChange: D,
        onFocus: y,
        placeholder: x,
        step: w,
        value: R
      },
      C,
      v
    );
    return /* @__PURE__ */ f(ue, { children: [
      /* @__PURE__ */ t(
        "input",
        {
          ...$,
          ...j,
          "aria-required": l,
          ref: v,
          className: b(
            Ie.input,
            d && Ie["input--invalid"],
            r
          )
        }
      ),
      /* @__PURE__ */ t(F, { when: h, children: /* @__PURE__ */ t(
        "input",
        {
          type: "hidden",
          name: h,
          value: isNaN(C.numberValue) ? "" : C.numberValue
        }
      ) })
    ] });
  }
), Xe = {
  "input-group": "_input-group_quapc_1",
  "input-group__label": "_input-group__label_quapc_10",
  "input-group--disabled": "_input-group--disabled_quapc_26"
};
function rn({
  children: n,
  className: e,
  disabled: a = !1,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: i,
  ...l
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: b(
        Xe["input-group"],
        a && Xe["input-group--disabled"],
        e
      ),
      ...l,
      children: n
    }
  );
}
function ze({ className: n, ...e }) {
  return /* @__PURE__ */ t(
    "div",
    {
      "aria-hidden": !0,
      ...e,
      className: b(Xe["input-group__label"], n)
    }
  );
}
const Kl = "_dialog_dwn7l_5", Ql = "_centered_dwn7l_27", Xl = "_header_dwn7l_38", Jl = "_body_dwn7l_48", Yl = "_footer_dwn7l_53", Pe = {
  dialog: Kl,
  centered: Ql,
  header: Xl,
  body: Jl,
  footer: Yl
}, er = ({ children: n, className: e }) => /* @__PURE__ */ t("div", { className: b(Pe.body, e), children: n }), on = ee({
  dialogRef: { current: null },
  modalContentId: "changeme",
  modalDescriptionId: "changeme",
  modalTitleId: "changeme",
  open: !1,
  onOpenChange: () => {
  }
}), Ae = () => H(on), cn = ({ asChild: n, ...e }) => {
  const { onOpenChange: a } = Ae();
  return /* @__PURE__ */ t(n ? me : "button", { onClick: (r) => {
    r.defaultPrevented || a(!1);
  }, ...e });
};
function tr(n, e) {
  const a = e.getBoundingClientRect();
  return n.clientX >= a.left && n.clientX <= a.right && n.clientY >= a.top && n.clientY <= a.bottom;
}
const nr = ({
  alwaysCentered: n,
  children: e,
  className: a,
  closeOnBackdropClick: i = !1
}) => {
  const {
    dialogRef: l,
    modalContentId: r,
    modalDescriptionId: o,
    modalTitleId: c,
    open: _,
    onOpenChange: s
  } = Ae();
  ga({
    isDisabled: !_
  });
  const d = ce(
    (u) => {
      !i || !l.current || tr(u, l.current) || s(!1);
    },
    [l, i, s]
  );
  return (
    // ESLint might complain about the `role` attribute being redundant,
    // but when omitting it certain browsers fail to announce the dialog
    // as an actual dialog, so we'll keep it until we confirm that it is
    // no longer needed.
    // TODO: Make sure that we don't have to follow any of the disabled eslint rules.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-redundant-roles
    /* @__PURE__ */ t(
      "dialog",
      {
        ref: l,
        id: r,
        "aria-labelledby": c,
        "aria-describedby": o,
        "aria-modal": "true",
        role: "dialog",
        className: b(
          Pe.dialog,
          n && Pe.centered,
          a
        ),
        onClick: d,
        children: e
      }
    )
  );
}, ar = ({ children: n, className: e }) => /* @__PURE__ */ t("div", { className: b(Pe.footer, e), children: n }), ir = "_prose_1vzo1_1", lr = {
  prose: ir
};
function Bo({ as: n = "div", className: e, ...a }) {
  return Bt(n, {
    ...a,
    className: b(lr.prose, e)
  });
}
const rr = "_text_u5ryy_5", fe = {
  text: rr,
  "text--display": "_text--display_u5ryy_47",
  "text--h1": "_text--h1_u5ryy_53",
  "text--h2": "_text--h2_u5ryy_59",
  "text--h3": "_text--h3_u5ryy_65",
  "text--lead": "_text--lead_u5ryy_71",
  "text--paragraph": "_text--paragraph_u5ryy_77",
  "text--base": "_text--base_u5ryy_83",
  "text--caption": "_text--caption_u5ryy_89",
  "text--fineprint": "_text--fineprint_u5ryy_95",
  "text--mb": "_text--mb_u5ryy_101",
  "text--mt": "_text--mt_u5ryy_105",
  "text--mb-0x": "_text--mb-0x_u5ryy_109",
  "text--mb-0.5x": "_text--mb-0.5x_u5ryy_113",
  "text--mb-1x": "_text--mb-1x_u5ryy_117",
  "text--mb-2x": "_text--mb-2x_u5ryy_121",
  "text--mb-3x": "_text--mb-3x_u5ryy_125",
  "text--mb-4x": "_text--mb-4x_u5ryy_129",
  "text--mb-6x": "_text--mb-6x_u5ryy_133",
  "text--mb-8x": "_text--mb-8x_u5ryy_137",
  "text--mb-10x": "_text--mb-10x_u5ryy_141",
  "text--mt-0x": "_text--mt-0x_u5ryy_145",
  "text--mt-0.5x": "_text--mt-0.5x_u5ryy_149",
  "text--mt-1x": "_text--mt-1x_u5ryy_153",
  "text--mt-2x": "_text--mt-2x_u5ryy_157",
  "text--mt-3x": "_text--mt-3x_u5ryy_161",
  "text--mt-4x": "_text--mt-4x_u5ryy_165",
  "text--mt-6x": "_text--mt-6x_u5ryy_169",
  "text--mt-8x": "_text--mt-8x_u5ryy_173",
  "text--mt-10x": "_text--mt-10x_u5ryy_177"
}, or = {
  h1: "h1",
  h2: "h2",
  h3: "h3"
};
function cr({
  as: n = "p",
  children: e,
  className: a,
  mb: i,
  mt: l,
  size: r = or[n],
  ...o
}, c) {
  return Bt(
    n,
    {
      ...o,
      ref: c,
      className: b(
        fe.text,
        r && fe[`text--${r}`],
        i && fe["text--mb"],
        i && fe[`text--mb-${i}`],
        l && fe["text--mt"],
        l && fe[`text--mt-${l}`],
        a
      )
    },
    e
  );
}
const Re = /* @__PURE__ */ k(cr);
function ne(n, e, a) {
  function i(l) {
    return /* @__PURE__ */ t(Re, { as: n, size: e, ...l });
  }
  return i.displayName = a, i;
}
const To = /* @__PURE__ */ ne("h1", "display", "Display"), Fo = /* @__PURE__ */ ne("h1", "h1", "H1"), Mo = /* @__PURE__ */ ne("h2", "h2", "H2"), Lo = /* @__PURE__ */ ne("h3", "h3", "H3"), jo = /* @__PURE__ */ ne("p", "lead", "Lead"), zo = /* @__PURE__ */ ne(
  "p",
  "paragraph",
  "Paragraph"
), qo = /* @__PURE__ */ ne("p", "base", "Base"), Ao = /* @__PURE__ */ ne("p", "caption", "Caption"), Oo = /* @__PURE__ */ ne(
  "p",
  "fineprint",
  "Fineprint"
), sn = ({ asChild: n, ...e }) => {
  const { modalTitleId: a } = Ae();
  return n ? /* @__PURE__ */ t(me, { ...e, id: a }) : /* @__PURE__ */ t(Re, { ...e, as: "h2", id: a });
}, sr = "_button_ml4dw_5", dr = "_icon_ml4dw_19", St = {
  button: sr,
  icon: dr
}, _r = (n) => /* @__PURE__ */ t(cn, { className: b(St.button, n.className), ...n, children: /* @__PURE__ */ t(L, { asChild: !0, align: "center", gap: ".25rem", children: /* @__PURE__ */ f("span", { children: [
  /* @__PURE__ */ t(Re, { as: "span", size: "paragraph", children: n.children }),
  /* @__PURE__ */ t(Mt, { className: St.icon, "aria-hidden": !0 })
] }) }) }), ur = ({
  children: n,
  closeButtonLabel: e = "Stäng"
}) => /* @__PURE__ */ f(L, { justify: "space-between", align: "center", className: b(Pe.header), children: [
  n ? /* @__PURE__ */ t(sn, { asChild: !0, children: /* @__PURE__ */ t(Re, { as: "h2", size: "lead", children: n }) }) : /* @__PURE__ */ t(qn, { width: "5rem", height: "auto" }),
  /* @__PURE__ */ t(_r, { children: e })
] });
function pr(n, e) {
  pe(() => {
    if (!e)
      return;
    const a = n.current, i = () => {
      var l;
      if (typeof e == "string") {
        (l = document.getElementById(e)) == null || l.focus();
        return;
      }
      if (e.current) {
        e.current.focus();
        return;
      }
    };
    return a == null || a.addEventListener("close", i), () => {
      a == null || a.removeEventListener("close", i);
    };
  }, [e, n]);
}
function mr(n, e) {
  pe(() => {
    const a = (l) => {
      l.preventDefault(), e(!1);
    }, i = n.current;
    return i == null || i.addEventListener("cancel", a), () => {
      i == null || i.removeEventListener("cancel", a);
    };
  }, [e, n]);
}
function hr(n, e) {
  pe(() => {
    var a, i, l;
    e ? ((a = n.current) == null || a.showModal(), (i = n.current) == null || i.focus()) : (l = n.current) == null || l.close();
  }, [e, n]);
}
const br = ({ focusOnClose: n, ...e }) => {
  const a = O(null), [i, l] = Se(!1), r = K(), o = e.open ?? i, c = e.onOpenChange ?? l, _ = Z(() => ({
    dialogRef: a,
    modalContentId: `${r}-content`,
    modalDescriptionId: `${r}-description`,
    modalTitleId: `${r}-title`,
    open: o,
    onOpenChange: c
  }), [r, o, c]);
  return pr(a, n), mr(a, c), hr(a, o), /* @__PURE__ */ t(on.Provider, { value: _, children: e.children });
}, gr = ({ asChild: n, ...e }) => {
  const { modalContentId: a, open: i, onOpenChange: l } = Ae();
  return /* @__PURE__ */ t(
    n ? me : "button",
    {
      ...e,
      "aria-controls": a,
      "aria-expanded": i,
      "aria-haspopup": "dialog",
      onClick: (c) => {
        c.defaultPrevented || l(!0);
      }
    }
  );
}, Wo = {
  Body: er,
  Close: cn,
  Content: nr,
  Footer: ar,
  Header: ur,
  Root: br,
  Title: sn,
  Trigger: gr
};
function fr({
  "aria-label": n,
  defaultValue: e,
  disabled: a,
  formatOptions: i,
  label: l,
  min: r,
  max: o,
  name: c,
  onBlur: _,
  onChange: s,
  onFocus: d,
  prefix: u,
  prefixAriaLabel: p,
  step: h,
  suffix: m,
  suffixAriaLabel: g,
  value: y,
  ...x
}, w) {
  let N = {}, $ = Tt;
  (u || m) && (N = { disabled: a }, $ = rn);
  let I = l;
  return l && (I = /* @__PURE__ */ f(ue, { children: [
    l,
    /* @__PURE__ */ t(F, { when: p, children: /* @__PURE__ */ t(Y, { children: p }) }),
    /* @__PURE__ */ t(F, { when: g, children: /* @__PURE__ */ t(Y, { children: g }) })
  ] })), /* @__PURE__ */ t(te, { ...x, label: I, children: (P, R) => /* @__PURE__ */ f($, { ...N, children: [
    /* @__PURE__ */ t(F, { when: u, children: /* @__PURE__ */ t(ze, { children: u }) }),
    /* @__PURE__ */ t(
      Zl,
      {
        ...P,
        ref: w,
        "aria-label": n,
        invalid: R.isInvalid,
        defaultValue: e,
        disabled: a,
        formatOptions: i,
        min: r,
        max: o,
        name: c,
        onBlur: _,
        onChange: s,
        onFocus: d,
        step: h,
        value: y
      }
    ),
    /* @__PURE__ */ t(F, { when: m, children: /* @__PURE__ */ t(ze, { children: m }) })
  ] }) });
}
const Eo = /* @__PURE__ */ k(
  fr
), yr = "_group_c9d7a_5", xr = "_button_c9d7a_23", vr = "_input_c9d7a_53", Je = {
  group: yr,
  button: xr,
  input: vr
};
function Rt(n) {
  const e = O(null), { buttonProps: a } = qt(n, e);
  return /* @__PURE__ */ t("button", { ...a, ref: e, className: Je.button, children: n.children });
}
const Ho = /* @__PURE__ */ k(
  function({
    "aria-label": e,
    "aria-labelledby": a,
    "aria-describedby": i,
    "aria-required": l,
    decrementAriaLabel: r,
    defaultValue: o,
    description: c,
    descriptionProps: _ = {},
    disabled: s,
    incrementAriaLabel: d,
    inputClassName: u,
    inputProps: p,
    inputRef: h,
    label: m,
    labelProps: g = {},
    max: y,
    min: x,
    message: w,
    messageProps: N,
    messageTone: $,
    name: I,
    validationError: P,
    validationErrorProps: R,
    onBlur: B,
    onChange: D,
    onFocus: C,
    step: v,
    value: j,
    ...V
  }, W) {
    const [M, z] = se(
      j,
      o ?? NaN,
      NaN
    ), ae = !!(P || $ === "critical"), ie = {
      "aria-label": m ? void 0 : e,
      "aria-labelledby": m ? void 0 : a,
      "aria-describedby": c ? void 0 : i,
      minValue: x,
      maxValue: y,
      label: m,
      description: c,
      isDisabled: s,
      onBlur: B,
      onChange(ke) {
        z(ke), D == null || D(Number.isNaN(ke) ? void 0 : ke);
      },
      onFocus: C,
      defaultValue: o === null ? NaN : o,
      step: v,
      value: M
    }, de = he(), Q = Ot({
      ...ie,
      isInvalid: ae,
      locale: ct(de)
    }), T = O(null);
    ve(h, () => T.current);
    const {
      groupProps: be,
      labelProps: De,
      descriptionProps: Ne,
      inputProps: Ve,
      incrementButtonProps: E,
      decrementButtonProps: ft
    } = At(ie, Q, T);
    return r && (ft["aria-label"] = r), d && (E["aria-label"] = d), /* @__PURE__ */ t(
      te,
      {
        ...V,
        "aria-required": l,
        label: m,
        labelProps: { ...g, ...De },
        labelId: De.id,
        description: c,
        descriptionProps: { ..._, ...Ne },
        descriptionId: Ne.id,
        message: w,
        messageProps: N,
        messageTone: $,
        validationError: P,
        validationErrorProps: R,
        ref: W,
        children: (ke) => /* @__PURE__ */ f(ue, { children: [
          /* @__PURE__ */ f("div", { ...be, className: Je.group, children: [
            /* @__PURE__ */ t(Rt, { ...ft, children: /* @__PURE__ */ t("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: /* @__PURE__ */ t(
              "rect",
              {
                fill: "currentColor",
                x: "5",
                y: "11",
                width: "14",
                height: "2"
              }
            ) }) }),
            /* @__PURE__ */ t(
              "input",
              {
                ...Ve,
                ...p,
                ...ke,
                ref: T,
                className: b(Je.input, u)
              }
            ),
            /* @__PURE__ */ t(Rt, { ...E, children: /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: [
              /* @__PURE__ */ t(
                "rect",
                {
                  fill: "currentColor",
                  x: "5",
                  y: "11",
                  width: "14",
                  height: "2"
                }
              ),
              /* @__PURE__ */ t(
                "rect",
                {
                  fill: "currentColor",
                  x: "11",
                  y: "5",
                  width: "2",
                  height: "14"
                }
              )
            ] }) })
          ] }),
          I && /* @__PURE__ */ t(
            "input",
            {
              type: "hidden",
              name: I,
              value: isNaN(Q.numberValue) ? "" : Q.numberValue
            }
          )
        ] })
      }
    );
  }
), wr = "_radio__input_1usru_5", Nr = "_radio__label_1usru_10", Dt = {
  radio__input: wr,
  radio__label: Nr
}, dn = ee(null);
function kr({
  checked: n,
  className: e,
  defaultChecked: a,
  disabled: i = !1,
  id: l,
  innerRef: r,
  inputClassName: o,
  inputProps: c = {},
  inputRef: _,
  label: s,
  labelClassName: d,
  labelProps: u = {},
  labelRef: p,
  name: h,
  onBlur: m,
  onChange: g,
  onFocus: y,
  value: x,
  ...w
}, N) {
  const $ = H(dn), I = ce(
    (D) => {
      g && g(D), $ != null && $.onChange && $.onChange(D);
    },
    [g, $ == null ? void 0 : $.onChange]
  ), P = `radio-${we()}`, R = l ?? P;
  let B = n;
  return $ && (B = $.value === x), /* @__PURE__ */ f(
    "div",
    {
      ...w,
      ref: N ?? r,
      className: e,
      onClick: (D) => {
        D.target.localName === "input" && D.target.focus(), typeof w.onClick == "function" && w.onClick(D);
      },
      children: [
        /* @__PURE__ */ t(
          "input",
          {
            ...c,
            checked: B,
            className: b(Dt.radio__input, o),
            defaultChecked: a,
            disabled: i,
            id: R,
            name: h ?? ($ == null ? void 0 : $.name),
            onBlur: m,
            onChange: I,
            onFocus: y,
            ref: _,
            type: "radio",
            value: x
          }
        ),
        /* @__PURE__ */ t(
          "label",
          {
            ...u,
            htmlFor: R,
            ref: p,
            className: b(Dt.radio__label, d),
            children: s
          }
        )
      ]
    }
  );
}
const Cr = /* @__PURE__ */ k(
  kr
), Vt = {
  "radio-group--row": "_radio-group--row_6ppsz_1"
};
function Ir({
  children: n,
  description: e,
  label: a,
  message: i,
  name: l,
  onChange: r,
  row: o,
  secondaryLabel: c,
  supplemental: _,
  tone: s,
  value: d,
  ...u
}) {
  const p = we(), h = `label-${p}`, m = `description-${p}`, g = `message-${p}`, y = ce(
    (N) => {
      r && r(N.currentTarget.value);
    },
    [r]
  ), x = Z(
    () => ({
      name: l,
      onChange: y,
      value: d ?? ""
    }),
    [l, y, d]
  );
  let w;
  return (i || e) && (w = [e && m, i && g].filter(Boolean).join(" ")), /* @__PURE__ */ f(L, { ...u, direction: "column", gap: "0.5rem", children: [
    a && /* @__PURE__ */ f("div", { children: [
      /* @__PURE__ */ t(
        tt,
        {
          id: h,
          secondaryLabel: e ? void 0 : c,
          children: a
        }
      ),
      typeof e < "u" && /* @__PURE__ */ t(et, { id: m, children: e })
    ] }),
    _,
    /* @__PURE__ */ t(dn.Provider, { value: x, children: /* @__PURE__ */ t(
      "div",
      {
        role: "radiogroup",
        "aria-labelledby": h,
        "aria-describedby": w,
        "aria-invalid": s === "critical",
        className: b(
          Vt["radio-group"],
          o && Vt["radio-group--row"]
        ),
        children: n
      }
    ) }),
    i && /* @__PURE__ */ t(Le, { id: g, tone: s, children: i })
  ] });
}
const $r = "_item_snw19_5", Pr = "_indicator_snw19_13", Sr = "_circle_snw19_16", Rr = "_label_snw19_30", $e = {
  item: $r,
  indicator: Pr,
  circle: Sr,
  "inner-circle": "_inner-circle_snw19_21",
  label: Rr
}, _n = ee({
  handleChange: () => {
  }
}), dt = ee({
  isChecked: !1
});
function _t({
  children: n,
  defaultValue: e,
  disabled: a,
  name: i,
  onBlur: l,
  onChange: r,
  onFocus: o,
  value: c,
  ..._
}) {
  const [s, d] = se(
    c,
    e ?? "",
    ""
  ), u = s, p = ce(
    (g) => {
      d(g.target.value), r == null || r(g.target.value);
    },
    [r, d]
  ), h = K(), { focusWithinProps: m } = zt({
    onBlurWithin: l,
    onFocusWithin: o
  });
  return /* @__PURE__ */ t(
    _n.Provider,
    {
      value: {
        disabled: a,
        handleChange: p,
        name: i ?? h,
        selectedValue: u
      },
      children: /* @__PURE__ */ t("div", { ..._, ...m, role: "radiogroup", children: n })
    }
  );
}
const ut = /* @__PURE__ */ k(
  function({ children: e, className: a, disabled: i, style: l, value: r }, o) {
    const {
      disabled: c,
      handleChange: _,
      name: s,
      selectedValue: d
    } = H(_n), u = K(), p = `${u}-control`, h = `${u}-label`, m = d === r, g = c ?? i;
    return /* @__PURE__ */ t(
      dt.Provider,
      {
        value: {
          controlId: p,
          isChecked: m,
          labelId: h,
          value: r
        },
        children: /* @__PURE__ */ f(
          "label",
          {
            "data-disabled": g,
            className: b($e.item, a),
            style: l,
            children: [
              /* @__PURE__ */ t(Y, { children: /* @__PURE__ */ t(
                "input",
                {
                  type: "radio",
                  "aria-labelledby": h,
                  checked: m,
                  disabled: g,
                  id: p,
                  name: s,
                  onChange: _,
                  ref: o,
                  value: r
                }
              ) }),
              typeof e == "function" ? e == null ? void 0 : e({ isChecked: m, isDisabled: g }) : e
            ]
          }
        )
      }
    );
  }
);
function pt({ className: n }) {
  const { isChecked: e } = H(dt);
  return /* @__PURE__ */ f(
    "svg",
    {
      "aria-hidden": !0,
      width: "1.125rem",
      height: "1.125rem",
      viewBox: "0 0 18 18",
      className: b($e.indicator, n),
      children: [
        /* @__PURE__ */ t("circle", { cx: 9, cy: 9, r: 8.5, className: $e.circle }),
        e && /* @__PURE__ */ t("circle", { cx: 9, cy: 9, r: 4, className: $e["inner-circle"] })
      ]
    }
  );
}
function mt({ children: n, className: e }) {
  const { labelId: a } = H(dt);
  return /* @__PURE__ */ t("span", { className: b($e.label, e), id: a, children: n });
}
const _e = {
  "standard-item": "_standard-item_ssydz_5",
  "standard-indicator": "_standard-indicator_ssydz_8",
  "standard-label": "_standard-label_ssydz_13",
  "prominent-item": "_prominent-item_ssydz_17",
  "prominent-inner": "_prominent-inner_ssydz_23",
  "prominent-inner--checked": "_prominent-inner--checked_ssydz_31",
  "icon-container": "_icon-container_ssydz_35"
}, Dr = /* @__PURE__ */ k(
  function({
    className: e,
    defaultValue: a,
    name: i,
    onBlur: l,
    onChange: r,
    onFocus: o,
    options: c,
    value: _,
    ...s
  }, d) {
    return /* @__PURE__ */ t(te, { ...s, className: e, children: (u) => /* @__PURE__ */ t(
      _t,
      {
        ...u,
        defaultValue: a,
        name: i,
        onBlur: l,
        onChange: r,
        onFocus: o,
        value: _,
        children: /* @__PURE__ */ t(L, { direction: "column", gap: ".5rem", children: c.map((p, h) => /* @__PURE__ */ t(
          ut,
          {
            className: _e["standard-item"],
            value: p.value,
            ref: h ? void 0 : d,
            children: /* @__PURE__ */ f(L, { align: "flex-start", gap: ".5rem", children: [
              /* @__PURE__ */ t(pt, { className: _e["standard-indicator"] }),
              /* @__PURE__ */ t(mt, { className: _e["standard-label"], children: p.label })
            ] })
          },
          p.value
        )) })
      }
    ) });
  }
), Vr = /* @__PURE__ */ k(
  function({
    className: e,
    defaultValue: a,
    name: i,
    onBlur: l,
    onChange: r,
    onFocus: o,
    options: c,
    value: _,
    ...s
  }, d) {
    return /* @__PURE__ */ t(te, { ...s, className: e, children: (u) => /* @__PURE__ */ t(
      _t,
      {
        ...u,
        defaultValue: a,
        name: i,
        onBlur: l,
        onChange: r,
        onFocus: o,
        value: _,
        children: /* @__PURE__ */ t(L, { direction: "column", gap: ".5rem", children: c.map((p, h) => /* @__PURE__ */ t(
          ut,
          {
            value: p.value,
            ref: h ? void 0 : d,
            children: ({ isChecked: m }) => /* @__PURE__ */ t("div", { className: _e["prominent-item"], children: /* @__PURE__ */ f(
              L,
              {
                justify: "space-between",
                className: b(
                  _e["prominent-inner"],
                  m && _e["prominent-inner--checked"]
                ),
                gap: ".5rem",
                align: "center",
                children: [
                  /* @__PURE__ */ f(L, { align: "center", gap: ".5rem", children: [
                    /* @__PURE__ */ t(pt, {}),
                    /* @__PURE__ */ t(mt, { children: p.label })
                  ] }),
                  p.icon && /* @__PURE__ */ t(
                    L,
                    {
                      align: "center",
                      className: _e["icon-container"],
                      children: /* @__PURE__ */ t(p.icon, { size: "3em" })
                    }
                  )
                ]
              }
            ) })
          },
          p.value
        )) })
      }
    ) });
  }
), ht = Cr;
ht.Root = ut;
ht.Indicator = pt;
ht.Label = mt;
const bt = Ir;
bt.Root = _t;
bt.Standard = Dr;
bt.Prominent = Vr;
const Br = "_select_26a2x_5", Tr = "_select__input_26a2x_33", Fr = "_select_icon_26a2x_69", re = {
  select: Br,
  "select--disabled": "_select--disabled_26a2x_18",
  "select--invalid": "_select--invalid_26a2x_21",
  "select--large": "_select--large_26a2x_24",
  "select--small": "_select--small_26a2x_28",
  select__input: Tr,
  "select__input--large": "_select__input--large_26a2x_48",
  "select__input--small": "_select__input--small_26a2x_51",
  select_icon: Fr,
  "select_icon--large": "_select_icon--large_26a2x_75",
  "select_icon--small": "_select_icon--small_26a2x_79"
}, Mr = "_icon_kp4sy_1", Lr = {
  icon: Mr
};
function jr({ className: n, ...e }) {
  return /* @__PURE__ */ f(
    "svg",
    {
      ...e,
      "aria-hidden": !0,
      className: b(Lr.icon, n),
      width: "0.75rem",
      height: "1.5rem",
      viewBox: "0 0 12 24",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t("polyline", { points: "3,9 6,6 9,9", fill: "none", strokeWidth: "1.6" }),
        /* @__PURE__ */ t("polyline", { points: "3,15 6,18 9,15", fill: "none", strokeWidth: "1.6" })
      ]
    }
  );
}
function zr({
  "aria-describedby": n,
  "aria-invalid": e,
  "aria-labelledby": a,
  "aria-label": i,
  "aria-required": l,
  className: r,
  children: o,
  defaultValue: c,
  disabled: _,
  id: s,
  innerRef: d,
  inputClassName: u,
  inputProps: p = {},
  inputRef: h,
  invalid: m = !1,
  name: g,
  onBlur: y,
  onChange: x,
  onFocus: w,
  size: N,
  value: $,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: I,
  ...P
}, R) {
  return /* @__PURE__ */ f(
    "div",
    {
      ...P,
      className: b(
        re.select,
        N && re[`select--${N}`],
        _ && re["select--disabled"],
        m && re["select--invalid"],
        r
      ),
      ref: R ?? d,
      children: [
        /* @__PURE__ */ t(
          "select",
          {
            ...p,
            "aria-describedby": n,
            "aria-labelledby": a,
            "aria-label": i,
            "aria-invalid": m ? !0 : e,
            "aria-required": l,
            className: b(
              re.select__input,
              N && re[`select__input--${N}`],
              u
            ),
            defaultValue: c,
            disabled: _,
            id: s,
            name: g,
            onBlur: y,
            onChange: x,
            onFocus: w,
            ref: h,
            value: $,
            children: o
          }
        ),
        /* @__PURE__ */ t(
          jr,
          {
            className: b(
              re.select_icon,
              N && re[`select_icon--${N}`]
            )
          }
        )
      ]
    }
  );
}
const qr = /* @__PURE__ */ k(zr), un = /* @__PURE__ */ k(
  function({
    children: e,
    defaultValue: a,
    disabled: i = !1,
    inputClassName: l,
    inputProps: r = {},
    inputRef: o,
    name: c,
    onBlur: _,
    onChange: s,
    onChangeEvent: d,
    onFocus: u,
    size: p,
    value: h,
    ...m
  }, g) {
    const [y, x] = se(
      h,
      a ?? "",
      ""
    );
    return /* @__PURE__ */ t(te, { ...m, ref: g, children: (w, N) => /* @__PURE__ */ t(
      qr,
      {
        ...w,
        ...r,
        disabled: i,
        inputClassName: l,
        invalid: N.isInvalid,
        name: c,
        onBlur: _,
        onChange: ($) => {
          d == null || d($), s == null || s($.target.value), x($.target.value);
        },
        onFocus: u,
        ref: o,
        size: p,
        value: h ?? y,
        children: e
      }
    ) });
  }
), Ar = /* @__PURE__ */ k(function({ onChange: e, ...a }, i) {
  return /* @__PURE__ */ t(un, { ...a, onChangeEvent: e, ref: i });
}), Or = un;
Or.WithNativeOnChange = Ar;
const ye = {
  "step-indicator": "_step-indicator_39hft_5",
  "step-indicator__header": "_step-indicator__header_39hft_10",
  "step-indicator__label": "_step-indicator__label_39hft_16",
  "step-indicator__state": "_step-indicator__state_39hft_20",
  "step-indicator__progress-bar": "_step-indicator__progress-bar_39hft_32",
  "step-indicator__progress-fill": "_step-indicator__progress-fill_39hft_39"
}, Go = /* @__PURE__ */ k(
  function({ className: e, currentStep: a, id: i, steps: l }, r) {
    const o = he(), _ = `${K()}-title`, s = l.length, d = O(null), u = l[a - 1], p = Math.max(
      0,
      Math.min(100, a / s * 100)
    );
    return ve(r, () => ({
      focus() {
        var h;
        (h = d.current) == null || h.focus();
      }
    })), /* @__PURE__ */ f(
      "div",
      {
        tabIndex: -1,
        ref: d,
        id: i,
        "aria-labelledby": _,
        role: "meter",
        "aria-valuemin": 1,
        "aria-valuemax": s,
        "aria-valuenow": a,
        "aria-valuetext": o === "sv" ? `Steg ${a} av ${s}` : `Step ${a} of ${s}`,
        className: b(ye["step-indicator"], e),
        children: [
          /* @__PURE__ */ f("div", { className: ye["step-indicator__header"], children: [
            /* @__PURE__ */ t(
              Re,
              {
                as: "span",
                size: "paragraph",
                className: ye["step-indicator__label"],
                id: _,
                children: u
              }
            ),
            /* @__PURE__ */ f("span", { className: ye["step-indicator__state"], children: [
              a,
              " / ",
              s
            ] })
          ] }),
          /* @__PURE__ */ t("div", { className: ye["step-indicator__progress-bar"], children: /* @__PURE__ */ t(
            "div",
            {
              className: ye["step-indicator__progress-fill"],
              style: { width: `${p}%` }
            }
          ) })
        ]
      }
    );
  }
);
function Wr(n, e) {
  switch (e.type) {
    case "set":
    case "increment":
    case "decrement": {
      let a;
      if (e.type === "set")
        a = e.step;
      else {
        const i = e.type === "increment" ? 1 : -1;
        a = Math.min(
          Math.max(n.currentStep + i, 1),
          n.totalSteps
        );
      }
      return a === n.currentStep ? n : {
        ...n,
        currentStep: a,
        canGoBack: a > 1,
        canGoForward: a < n.totalSteps,
        isTouched: !0
      };
    }
    default:
      return n;
  }
}
function Er(n, e) {
  return {
    currentStep: e,
    totalSteps: n,
    canGoBack: e > 1,
    canGoForward: e < n,
    isTouched: !1
  };
}
function Uo({
  totalSteps: n,
  initialStep: e = 1,
  currentStep: a
}) {
  const [i, l] = In(
    Wr,
    Er(n, a ?? e)
  );
  return pe(() => {
    a && l({ type: "set", step: a });
  }, [a, l]), [
    i,
    {
      /**
       * Go to previous step, if possible.
       */
      prev: () => l({ type: "decrement" }),
      /**
       * Go to next step, if possible.
       */
      next: () => l({ type: "increment" })
    }
  ];
}
const Hr = "_root_1xusm_5", Gr = "_label_1xusm_9", Ur = "_thumb_1xusm_13", Zr = "_focused_1xusm_21", Kr = "_pressed_1xusm_26", Qr = "_thumb__circle_1xusm_26", Xr = "_thumb__rect_1xusm_30", Jr = "_checked_1xusm_34", J = {
  root: Hr,
  label: Gr,
  thumb: Ur,
  focused: Zr,
  pressed: Kr,
  thumb__circle: Qr,
  thumb__rect: Xr,
  checked: Jr
}, pn = /* @__PURE__ */ k(
  function(e, a) {
    const {
      checked: i,
      children: l,
      defaultChecked: r,
      disabled: o,
      name: c,
      onChange: _,
      className: s
    } = e, d = {
      "aria-hidden": e["aria-hidden"],
      "aria-label": e["aria-label"],
      "aria-labelledby": e["aria-labelledby"],
      "aria-describedby": e["aria-describedby"],
      role: e.role,
      id: e.id,
      style: e.style
    }, u = O(null), p = ba({
      onChange: _,
      // React ARIA-specific naming conventions
      defaultSelected: r,
      isDisabled: o,
      isSelected: i
    }), {
      inputProps: h,
      isDisabled: m,
      isSelected: g
    } = na(e, p, u), { isFocusVisible: y, focusProps: x } = aa(), [w, N] = Se(!1), { pressProps: $ } = ia({
      isDisabled: m,
      onPressStart(P) {
        P.pointerType !== "keyboard" && N(!0);
      },
      onPressEnd(P) {
        P.pointerType !== "keyboard" && N(!1);
      }
    }), { keyboardProps: I } = la({
      onKeyDown(P) {
        P.key === "Enter" && p.toggle();
      }
    });
    return ve(a, () => u.current ?? {}), /* @__PURE__ */ f(
      "label",
      {
        ...d,
        ...$,
        className: b(
          J.root,
          y && J.focused,
          w && J.pressed,
          m && J.disabled,
          g && J.checked,
          s
        ),
        children: [
          /* @__PURE__ */ t(Y, { children: /* @__PURE__ */ t(
            "input",
            {
              name: c,
              ...ra(h, x, I),
              ref: u
            }
          ) }),
          l
        ]
      }
    );
  }
);
function mn({
  children: n,
  className: e,
  ...a
}) {
  return /* @__PURE__ */ t("span", { ...a, className: b(J.label, e), children: n });
}
function hn({ className: n }) {
  return /* @__PURE__ */ f(
    "svg",
    {
      "aria-hidden": !0,
      viewBox: "0 0 40 24",
      width: 40,
      height: 24,
      className: b(J.thumb, n),
      children: [
        /* @__PURE__ */ t(
          "rect",
          {
            x: 0,
            y: 0,
            width: 40,
            height: 24,
            rx: 12,
            className: J.thumb__rect
          }
        ),
        /* @__PURE__ */ t("circle", { cx: 12, cy: 12, r: 10, className: J.thumb__circle })
      ]
    }
  );
}
function Yr({ children: n, ...e }) {
  return /* @__PURE__ */ t(pn, { ...e, children: /* @__PURE__ */ f(L, { align: "center", gap: "0.75rem", justify: "space-between", children: [
    /* @__PURE__ */ t(mn, { children: n }),
    /* @__PURE__ */ t(hn, {})
  ] }) });
}
const gt = Yr;
gt.Root = pn;
gt.Label = mn;
gt.Thumb = hn;
const eo = "_ascending_6jite_51", to = "_none_6jite_52", no = "_descending_6jite_52", U = {
  "table-root": "_table-root_6jite_5",
  "table-caption": "_table-caption_6jite_6",
  "table-body": "_table-body_6jite_7",
  "table-foot": "_table-foot_6jite_8",
  "table-head": "_table-head_6jite_9",
  "table-row": "_table-row_6jite_10",
  "table-header": "_table-header_6jite_11",
  "table-data": "_table-data_6jite_12",
  "sort-indicator": "_sort-indicator_6jite_43",
  ascending: eo,
  none: to,
  descending: no
}, bn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t("tbody", { ref: i, className: b(U["table-body"], e), ...a, children: n })
);
bn.displayName = "TableBody";
const gn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t(
    "caption",
    {
      ref: i,
      className: b(U["table-caption"], e),
      ...a,
      children: n
    }
  )
);
gn.displayName = "TableCaption";
const fn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t("td", { ref: i, className: b(U["table-data"], e), ...a, children: n })
);
fn.displayName = "TableData";
const yn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t("tfoot", { ref: i, className: b(U["table-foot"], e), ...a, children: n })
);
yn.displayName = "TableFoot";
const xn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t("thead", { ref: i, className: b(U["table-head"], e), ...a, children: n })
);
xn.displayName = "TableHead";
const vn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t(
    "th",
    {
      ref: i,
      className: b(U["table-header"], e),
      ...a,
      children: n
    }
  )
);
vn.displayName = "TableHeader";
const wn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t("table", { ref: i, className: b(U["table-root"], e), ...a, children: n })
);
wn.displayName = "TableRoot";
const Nn = k(
  ({ children: n, className: e, ...a }, i) => /* @__PURE__ */ t("tr", { ref: i, className: b(U["table-row"], e), ...a, children: n })
);
Nn.displayName = "TableRow";
const Zo = ({ direction: n, className: e }) => /* @__PURE__ */ f(
  "svg",
  {
    className: b(
      U["sort-indicator"],
      n ? U[n] : "",
      e
    ),
    width: "16",
    height: "16",
    viewBox: "0 0 100 100",
    children: [
      /* @__PURE__ */ t("polygon", { points: "25,40 50,10 75,40" }),
      /* @__PURE__ */ t("polygon", { points: "25,60 50,90 75,60" })
    ]
  }
), Ko = {
  Body: bn,
  Caption: gn,
  Data: fn,
  Foot: yn,
  Head: xn,
  Header: vn,
  Root: wn,
  Row: Nn
}, ao = "_textarea_1b9x2_5", Fe = {
  textarea: ao,
  "textarea--resizeable": "_textarea--resizeable_1b9x2_33",
  "textarea--resizeable-both": "_textarea--resizeable-both_1b9x2_33",
  "textarea--resizeable-vertical": "_textarea--resizeable-vertical_1b9x2_36",
  "textarea--resizeable-horizontal": "_textarea--resizeable-horizontal_1b9x2_39",
  "textarea--invalid": "_textarea--invalid_1b9x2_42"
};
function io({
  invalid: n = !1,
  className: e,
  resizeable: a = !1,
  innerRef: i,
  // Prevent block prop from ending up as an attribute on underlying element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  block: l,
  ...r
}, o) {
  return /* @__PURE__ */ t(
    "textarea",
    {
      ...r,
      ref: o ?? i,
      className: b(
        Fe.textarea,
        n && Fe["textarea--invalid"],
        a === !0 && Fe["textarea--resizeable"],
        typeof a == "string" && Fe[`textarea--resizeable-${a}`],
        e
      )
    }
  );
}
const lo = /* @__PURE__ */ k(io), kn = /* @__PURE__ */ k(
  function({
    defaultValue: e,
    disabled: a = !1,
    inputClassName: i,
    inputMode: l,
    inputProps: r = {},
    inputRef: o,
    label: c,
    name: _,
    onBlur: s,
    onChange: d,
    onChangeEvent: u,
    onFocus: p,
    placeholder: h,
    prefix: m,
    prefixAriaLabel: g,
    resizable: y,
    size: x,
    suffix: w,
    suffixAriaLabel: N,
    type: $,
    textarea: I = !1,
    value: P,
    ...R
  }, B) {
    const [D, C] = se(
      P,
      e ?? "",
      ""
    ), v = {
      ...r,
      className: i,
      disabled: a,
      inputMode: l,
      name: _,
      onChange(M) {
        u == null || u(M), d == null || d(M.target.value), C(M.target.value);
      },
      placeholder: h,
      ref: o,
      value: D
    };
    let j = {}, V = Tt;
    (m || w) && (j = { disabled: a }, V = rn);
    let W = c;
    return c && (W = /* @__PURE__ */ f(ue, { children: [
      c,
      /* @__PURE__ */ t(F, { when: g, children: /* @__PURE__ */ t(Y, { children: g }) }),
      /* @__PURE__ */ t(F, { when: N, children: /* @__PURE__ */ t(Y, { children: N }) })
    ] })), /* @__PURE__ */ t(te, { ...R, label: W, ref: B, children: (M, z) => I ? /* @__PURE__ */ t(
      lo,
      {
        ...M,
        ...v,
        invalid: z.isInvalid,
        onBlur: s,
        onFocus: p,
        resizeable: y
      }
    ) : /* @__PURE__ */ f(V, { ...j, children: [
      /* @__PURE__ */ t(F, { when: m, children: /* @__PURE__ */ t(ze, { children: m }) }),
      /* @__PURE__ */ t(
        Ul,
        {
          ...M,
          ...v,
          invalid: z.isInvalid,
          onBlur: s,
          onFocus: p,
          size: x,
          type: $
        }
      ),
      /* @__PURE__ */ t(F, { when: w, children: /* @__PURE__ */ t(ze, { children: w }) })
    ] }) });
  }
), ro = /* @__PURE__ */ k(function({ onChange: e, ...a }, i) {
  return /* @__PURE__ */ t(kn, { ...a, onChangeEvent: e, ref: i });
}), oo = kn;
oo.WithNativeOnChange = ro;
export {
  vo as Accordion,
  Ia as AccordionContent,
  Da as AccordionItem,
  Ba as AccordionRoot,
  Fa as AccordionTrigger,
  wo as Badge,
  qo as Base,
  Qa as Button,
  ko as ButtonLink,
  Co as Callout,
  Ao as Caption,
  qe as Checkbox,
  Jt as CheckboxGroup,
  He as Collapsible,
  ji as CollapsibleContent,
  Vi as CollapsibleRoot,
  Bi as CollapsibleTrigger,
  Ro as DatePicker,
  Do as DateRangePicker,
  Io as DeprecatedFeedbackCallout,
  et as Description,
  To as Display,
  Vo as ExclamationSpinner,
  Oo as Fineprint,
  L as Flex,
  te as FormField,
  $o as Grid,
  Fo as H1,
  Mo as H2,
  Lo as H3,
  No as I18nProvider,
  El as InformationCard,
  Ul as Input,
  rn as InputGroup,
  ze as InputGroupLabel,
  tt as Label,
  jo as Lead,
  ni as Link,
  Le as Message,
  Wo as Modal,
  er as ModalBody,
  cn as ModalClose,
  nr as ModalContent,
  ar as ModalFooter,
  ur as ModalHeader,
  br as ModalRoot,
  sn as ModalTitle,
  gr as ModalTrigger,
  Eo as NumberField,
  Zl as NumberInput,
  Ho as NumericStepper,
  zo as Paragraph,
  Bo as Prose,
  ht as Radio,
  bt as RadioGroup,
  qr as Select,
  Or as SelectField,
  F as Show,
  Zo as SortIndicator,
  Po as Spacer,
  Wa as Spinner,
  So as Stack,
  Go as StepIndicator,
  gt as Switch,
  mn as SwitchLabel,
  pn as SwitchRoot,
  hn as SwitchThumb,
  Ko as Table,
  Re as Text,
  oo as TextField,
  lo as Textarea,
  Y as VisuallyHidden,
  b as cx,
  tl as useFieldAriaProps,
  Uo as useStepIndicatorState
};
//# sourceMappingURL=index.es.js.map
